import {
  EmptySerializersModule991ju6pz9b79 as EmptySerializersModule,
  StringFormat2r2ka8mzcb3mi as StringFormat,
  SerializationException_init_$Create$1b97dv9p64p50 as SerializationException_init_$Create$,
  SEALED_getInstance3nsev85ow9059 as SEALED_getInstance,
  buildSerialDescriptor2873qmkp8r2ib as buildSerialDescriptor,
  serializerOrNull294cbc318ws50 as serializerOrNull,
  KSerializerzf77vz1967fq as KSerializer,
  Decoder23nde051s631g as Decoder,
  CompositeDecoder2tzm7wpwkr0og as CompositeDecoder,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
  serializer1x79l67jvwntn as serializer,
  InlinePrimitiveDescriptor3i6ccn1a4fw94 as InlinePrimitiveDescriptor,
  MapSerializer11kmegt3g5c1g as MapSerializer,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  STRING_getInstance2ou4lro9xn2qn as STRING_getInstance,
  ENUM_getInstance22lfbrqor0c0a as ENUM_getInstance,
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  serializer2lw83vwvpnyms as serializer_0,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  Encoderqvmrpqtq8hnu as Encoder,
  CompositeEncoderknecpkexzn3v as CompositeEncoder,
  ElementMarker33ojvsajwmzts as ElementMarker,
  SerializationExceptioneqrdve3ts2n9 as SerializationException,
  SerializationException_init_$Init$nhp5tm45z5re as SerializationException_init_$Init$,
  CLASS_getInstance14ex35co4jkrb as CLASS_getInstance,
  LIST_getInstancey7k5h8d5cvxt as LIST_getInstance,
  CONTEXTUAL_getInstance1845118lbzky0 as CONTEXTUAL_getInstance,
  PolymorphicKindla9gurooefwb as PolymorphicKind,
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  MAP_getInstance3s1t6byguxmp9 as MAP_getInstance,
  ENUMlmq49cvwy4ow as ENUM,
  contextual3hpp1gupsu4al as contextual,
  SerializersModuleCollector3dddz14wd7brg as SerializersModuleCollector,
  SealedClassSerializeriwipiibk55zc as SealedClassSerializer,
  jsonCachedSerialNameslxufy2gu43jt as jsonCachedSerialNames,
  AbstractDecoder35guh02ubh2hm as AbstractDecoder,
  AbstractPolymorphicSerializer1ccxwp48nfy58 as AbstractPolymorphicSerializer,
  DeserializationStrategy1z3z5pj9f7zc8 as DeserializationStrategy,
  findPolymorphicSerializer1nm87hvemahcj as findPolymorphicSerializer,
  MissingFieldException24tqif29emcmi as MissingFieldException,
  AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder,
  OBJECT_getInstance26229tfe4t547 as OBJECT_getInstance,
  findPolymorphicSerializerk638ixyjovk5 as findPolymorphicSerializer_0,
  SerializationStrategyh6ouydnm6hci as SerializationStrategy,
  serializer3ikrxnm8b29d6 as serializer_1,
  serializer36584sjyg5661 as serializer_2,
  serializer1q7c5q67ysppr as serializer_3,
  NamedValueDecoderzk26ztf92xbq as NamedValueDecoder,
  getContextualDescriptor2n1gf3b895yb8 as getContextualDescriptor,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  VOID3gxj6tk5isa35 as VOID,
  Unit_instance1fbcbse1fwigr as Unit_instance,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$3ewkh27kzt8z8 as IllegalArgumentException_init_$Create$,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_0,
  Enum3alwj03lh1n41 as Enum,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  StringBuilder_init_$Create$2qsge4ydj6bin as StringBuilder_init_$Create$,
  hashCodeq5arwsb9dgti as hashCode,
  joinToString1cxrrlmo0chqs as joinToString,
  KtMap140uvy3s5zad8 as KtMap,
  KtList3hktaavzmj137 as KtList,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toDouble1kn912gjoizjp as toDouble,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  ClosedRangehokgr73im9z3 as ClosedRange,
  contains2c50nlxg7en7o as contains,
  convertToInty04h231mmjoh as convertToInt,
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  IllegalStateException_init_$Create$2w9444nebyjns as IllegalStateException_init_$Create$,
  toLongOrNullutqivezb0wx1 as toLongOrNull,
  toULongOrNullojoyxi0i9tgj as toULongOrNull,
  ULong3f9k7s38t3rfp as ULong,
  Companion_getInstance1puqqwzccfvrg as Companion_getInstance,
  _ULong___get_data__impl__fggpzb2qlkrfp9zs48z as _ULong___get_data__impl__fggpzb,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  toBooleanStrictOrNull2j0md398tkvbj as toBooleanStrictOrNull,
  KProperty1ca4yb4wlo496 as KProperty1,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  lazy2hsh8ze7j6ikd as lazy,
  fromInt2ii0rejb1w62w as fromInt,
  _UInt___init__impl__l7qpdltd1eeof8nsuj as _UInt___init__impl__l7qpdl,
  UInt__toString_impl_dbgl213fqto411a11p0 as UInt__toString_impl_dbgl21,
  _ULong___init__impl__c78o9k1p6qzv0dh0bvg as _ULong___init__impl__c78o9k,
  ULong__toString_impl_f9au7kivnvhcxkib53 as ULong__toString_impl_f9au7k,
  _UByte___init__impl__g9hnc43ude1dscg1q30 as _UByte___init__impl__g9hnc4,
  UByte__toString_impl_v72jg2vnfngefiworp as UByte__toString_impl_v72jg,
  _UShort___init__impl__jigrne2jag2u7194ozm as _UShort___init__impl__jigrne,
  UShort__toString_impl_edaoee3e5ovvzk9wm4f as UShort__toString_impl_edaoee,
  captureStack1fzi4aczwc4hg as captureStack,
  charSequenceSubSequence1iwpdba8s3jc7 as charSequenceSubSequence,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  coerceAtMost322komnqp70ag as coerceAtMost,
  Collection1k04j3hzsbod0 as Collection,
  LinkedHashMap_init_$Create$1f9mb1z5f3dxn as LinkedHashMap_init_$Create$,
  ArrayList_init_$Create$149jv2ovkkvnt as ArrayList_init_$Create$,
  singleOrNullrknfaxokm1sl as singleOrNull,
  emptyMapr06gerzljqtm as emptyMap,
  getValue48kllevslyh6 as getValue,
  copyOf2ng0t8oizk6it as copyOf,
  arrayCopytctsywo3h7gj as arrayCopy,
  DeepRecursiveFunction3r49v8igsve1g as DeepRecursiveFunction,
  invoke246lvi6tzooz1 as invoke,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  DeepRecursiveScope1pqaydvh4vdcu as DeepRecursiveScope,
  Unitkvevlwgzwiuc as Unit,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  getKClass3t8tygqu4lcxf as getKClass,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  substringBefore3n7kj60w69hju as substringBefore,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  substringAfter1hku067gwr5ve as substringAfter,
  contains3ue2qo8xhmpf1 as contains_0,
  plus17rl43at52ays as plus,
  convertToByte2t4hntblnhq2k as convertToByte,
  convertToShortn6n5n7ruahkm as convertToShort,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  isFinite1tx0gn65nl9tj as isFinite,
  isFinite2t9l5a275mxm6 as isFinite_0,
  charCodeAt1yspne1d8erbm as charCodeAt,
  toUInt21lx0mz8wkp7c as toUInt,
  _UInt___get_data__impl__f0vqqw13y1a2xkii3dn as _UInt___get_data__impl__f0vqqw,
  toULong266mnyksbttkw as toULong,
  toUByteh6p4wmqswkrs as toUByte,
  _UByte___get_data__impl__jof9qr2p2xx2i2jvnz8 as _UByte___get_data__impl__jof9qr,
  toUShort7yqspfnhrot4 as toUShort,
  _UShort___get_data__impl__g0245hlms5v6vgvnl as _UShort___get_data__impl__g0245,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  toString3o7ifthqydp6e as toString_1,
  Companion_getInstanceuedpedmz4g65 as Companion_getInstance_0,
  Companion_getInstance1trnkq9cty7vr as Companion_getInstance_1,
  Companion_getInstance2du03jiluw9jj as Companion_getInstance_2,
  setOf45ia9pnfhe90 as setOf,
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  numberToChar93r9buh19yek as numberToChar,
  equals2v6cggk171b6e as equals_0,
  toByte4i43936u611k as toByte,
  startsWith26w8qjqapeeq6 as startsWith,
  single29ec4rh52687r as single,
  Char19o2r8palgjof as Char,
  emptySetcxexqki71qfa as emptySet,
  plus1ogy4liedzq5j as plus_0,
  toInt2q8uldh7sc951 as toInt,
  toList3jhuyej2anx2q as toList,
  enumEntries20mr21zbe3az4 as enumEntries,
  toNumber2e2hj9zugjwi2 as toNumber,
  last1vo29oleiqj36 as last,
  removeLast3759euu1xvfa3 as removeLast,
  lastIndexOf2d52xhix5ymjr as lastIndexOf,
  Char__minus_impl_a2frrh3548ixwefqxih as Char__minus_impl_a2frrh,
  multiply2k9eolhnz1bjv as multiply,
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  numberToLong2pakxeg38estk as numberToLong,
  negate13xrbakfwasjy as negate,
  charArray2ujmm1qusno00 as charArray,
  indexOfwa4w6635jewi as indexOf,
  indexOf1xbs558u7wr52 as indexOf_0,
  substringiqarkczpya5m as substring,
  StringBuilder_init_$Create$2ujvu6cqvzuyn as StringBuilder_init_$Create$_0,
  HashMap_init_$Create$36kepqnl5avn5 as HashMap_init_$Create$,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(Json, 'Json', VOID, VOID, [StringFormat]);
initMetadataForObject(Default, 'Default', VOID, Json);
initMetadataForClass(JsonBuilder, 'JsonBuilder');
initMetadataForClass(JsonImpl, 'JsonImpl', VOID, Json);
initMetadataForClass(JsonClassDiscriminator, 'JsonClassDiscriminator');
initMetadataForClass(JsonIgnoreUnknownKeys, 'JsonIgnoreUnknownKeys');
initMetadataForClass(JsonNames, 'JsonNames');
initMetadataForClass(JsonConfiguration, 'JsonConfiguration');
initMetadataForClass(ClassDiscriminatorMode, 'ClassDiscriminatorMode', VOID, Enum);
initMetadataForClass(JsonContentPolymorphicSerializer, 'JsonContentPolymorphicSerializer', VOID, VOID, [KSerializer]);
initMetadataForInterface(JsonDecoder, 'JsonDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
initMetadataForCompanion(Companion);
initMetadataForClass(JsonElement, 'JsonElement', VOID, VOID, VOID, VOID, VOID, {0: JsonElementSerializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(JsonObject, 'JsonObject', VOID, JsonElement, [JsonElement, KtMap], VOID, VOID, {0: JsonObjectSerializer_getInstance});
initMetadataForCompanion(Companion_1);
initMetadataForClass(JsonPrimitive, 'JsonPrimitive', VOID, JsonElement, VOID, VOID, VOID, {0: JsonPrimitiveSerializer_getInstance});
initMetadataForCompanion(Companion_2);
initMetadataForClass(JsonArray, 'JsonArray', VOID, JsonElement, [JsonElement, KtList], VOID, VOID, {0: JsonArraySerializer_getInstance});
initMetadataForObject(JsonNull, 'JsonNull', VOID, JsonPrimitive, [JsonPrimitive, SerializerFactory], VOID, VOID, {0: JsonNullSerializer_getInstance});
initMetadataForClass(JsonLiteral, 'JsonLiteral', VOID, JsonPrimitive);
initMetadataForObject(JsonElementSerializer, 'JsonElementSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonObjectDescriptor, 'JsonObjectDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonObjectSerializer, 'JsonObjectSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonPrimitiveSerializer, 'JsonPrimitiveSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonNullSerializer, 'JsonNullSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonLiteralSerializer, 'JsonLiteralSerializer', VOID, VOID, [KSerializer]);
initMetadataForObject(JsonArrayDescriptor, 'JsonArrayDescriptor', VOID, VOID, [SerialDescriptor]);
initMetadataForObject(JsonArraySerializer, 'JsonArraySerializer', VOID, VOID, [KSerializer]);
initMetadataForClass(defer$1, VOID, VOID, VOID, [SerialDescriptor]);
initMetadataForInterface(JsonEncoder, 'JsonEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
initMetadataForClass(Composer, 'Composer');
initMetadataForClass(ComposerForUnsignedNumbers, 'ComposerForUnsignedNumbers', VOID, Composer);
initMetadataForClass(ComposerForUnquotedLiterals, 'ComposerForUnquotedLiterals', VOID, Composer);
initMetadataForClass(ComposerWithPrettyPrint, 'ComposerWithPrettyPrint', VOID, Composer);
initMetadataForClass(JsonElementMarker, 'JsonElementMarker');
initMetadataForClass(JsonException, 'JsonException', VOID, SerializationException);
initMetadataForClass(JsonDecodingException, 'JsonDecodingException', VOID, JsonException);
initMetadataForClass(JsonEncodingException, 'JsonEncodingException', VOID, JsonException);
initMetadataForObject(Tombstone, 'Tombstone');
initMetadataForClass(JsonPath, 'JsonPath', JsonPath);
initMetadataForClass(JsonSerializersModuleValidator, 'JsonSerializersModuleValidator', VOID, VOID, [SerializersModuleCollector]);
initMetadataForLambda(JsonTreeReader$readDeepRecursive$slambda, CoroutineImpl, VOID, [2]);
initMetadataForCoroutine($readObjectCOROUTINE$, CoroutineImpl);
initMetadataForClass(JsonTreeReader, 'JsonTreeReader', VOID, VOID, VOID, [1]);
initMetadataForClass(Key, 'Key', Key);
initMetadataForClass(DescriptorSchemaCache, 'DescriptorSchemaCache', DescriptorSchemaCache);
initMetadataForClass(DiscriminatorHolder, 'DiscriminatorHolder');
initMetadataForClass(StreamingJsonDecoder, 'StreamingJsonDecoder', VOID, AbstractDecoder, [JsonDecoder, AbstractDecoder]);
initMetadataForClass(JsonDecoderForUnsignedTypes, 'JsonDecoderForUnsignedTypes', VOID, AbstractDecoder);
initMetadataForClass(StreamingJsonEncoder, 'StreamingJsonEncoder', VOID, AbstractEncoder, [JsonEncoder, AbstractEncoder]);
initMetadataForClass(AbstractJsonTreeDecoder, 'AbstractJsonTreeDecoder', VOID, NamedValueDecoder, [NamedValueDecoder, JsonDecoder]);
initMetadataForClass(JsonTreeDecoder, 'JsonTreeDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonTreeListDecoder, 'JsonTreeListDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonPrimitiveDecoder, 'JsonPrimitiveDecoder', VOID, AbstractJsonTreeDecoder);
initMetadataForClass(JsonTreeMapDecoder, 'JsonTreeMapDecoder', VOID, JsonTreeDecoder);
initMetadataForClass(WriteMode, 'WriteMode', VOID, Enum);
initMetadataForClass(AbstractJsonLexer, 'AbstractJsonLexer');
initMetadataForObject(CharMappings, 'CharMappings');
initMetadataForClass(StringJsonLexer, 'StringJsonLexer', VOID, AbstractJsonLexer);
initMetadataForClass(StringJsonLexerWithComments, 'StringJsonLexerWithComments', VOID, StringJsonLexer);
initMetadataForClass(JsonToStringWriter, 'JsonToStringWriter', JsonToStringWriter);
//endregion
function Default() {
  Default_instance = this;
  Json.call(this, new JsonConfiguration(), EmptySerializersModule());
}
var Default_instance;
function Default_getInstance() {
  if (Default_instance == null)
    new Default();
  return Default_instance;
}
function Json(configuration, serializersModule) {
  Default_getInstance();
  this.v19_1 = configuration;
  this.w19_1 = serializersModule;
  this.x19_1 = new DescriptorSchemaCache();
}
protoOf(Json).ht = function () {
  return this.w19_1;
};
protoOf(Json).iq = function (serializer, value) {
  var result = new JsonToStringWriter();
  try {
    encodeByWriter(this, result, serializer, value);
    return result.toString();
  }finally {
    result.b1a();
  }
};
protoOf(Json).jq = function (deserializer, string) {
  var lexer = StringJsonLexer_0(this, string);
  var input = new StreamingJsonDecoder(this, WriteMode_OBJ_getInstance(), lexer, deserializer.fp(), null);
  var result = input.rs(deserializer);
  lexer.o1a();
  return result;
};
protoOf(Json).y19 = function (deserializer, element) {
  return readJson(this, element, deserializer);
};
protoOf(Json).z19 = function (string) {
  return this.jq(JsonElementSerializer_getInstance(), string);
};
function Json_0(from, builderAction) {
  from = from === VOID ? Default_getInstance() : from;
  var builder = new JsonBuilder(from);
  builderAction(builder);
  var conf = builder.h1b();
  return new JsonImpl(conf, builder.g1b_1);
}
function JsonBuilder(json) {
  this.p1a_1 = json.v19_1.i1b_1;
  this.q1a_1 = json.v19_1.n1b_1;
  this.r1a_1 = json.v19_1.j1b_1;
  this.s1a_1 = json.v19_1.k1b_1;
  this.t1a_1 = json.v19_1.m1b_1;
  this.u1a_1 = json.v19_1.o1b_1;
  this.v1a_1 = json.v19_1.p1b_1;
  this.w1a_1 = json.v19_1.r1b_1;
  this.x1a_1 = json.v19_1.y1b_1;
  this.y1a_1 = json.v19_1.t1b_1;
  this.z1a_1 = json.v19_1.u1b_1;
  this.a1b_1 = json.v19_1.v1b_1;
  this.b1b_1 = json.v19_1.w1b_1;
  this.c1b_1 = json.v19_1.x1b_1;
  this.d1b_1 = json.v19_1.s1b_1;
  this.e1b_1 = json.v19_1.l1b_1;
  this.f1b_1 = json.v19_1.q1b_1;
  this.g1b_1 = json.ht();
}
protoOf(JsonBuilder).h1b = function () {
  if (this.f1b_1) {
    // Inline function 'kotlin.require' call
    if (!(this.w1a_1 === 'type')) {
      var message = 'Class discriminator should not be specified when array polymorphism is specified';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!this.x1a_1.equals(ClassDiscriminatorMode_POLYMORPHIC_getInstance())) {
      var message_0 = 'useArrayPolymorphism option can only be used if classDiscriminatorMode in a default POLYMORPHIC state.';
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
  }
  if (!this.t1a_1) {
    // Inline function 'kotlin.require' call
    if (!(this.u1a_1 === '    ')) {
      var message_1 = 'Indent should not be specified when default printing mode is used';
      throw IllegalArgumentException_init_$Create$(toString(message_1));
    }
  } else if (!(this.u1a_1 === '    ')) {
    var tmp0 = this.u1a_1;
    var tmp$ret$7;
    $l$block: {
      // Inline function 'kotlin.text.all' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(tmp0)) {
        var element = charSequenceGet(tmp0, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (!(element === _Char___init__impl__6a9atx(32) || element === _Char___init__impl__6a9atx(9) || element === _Char___init__impl__6a9atx(13) || element === _Char___init__impl__6a9atx(10))) {
          tmp$ret$7 = false;
          break $l$block;
        }
      }
      tmp$ret$7 = true;
    }
    var allWhitespaces = tmp$ret$7;
    // Inline function 'kotlin.require' call
    if (!allWhitespaces) {
      var message_2 = 'Only whitespace, tab, newline and carriage return are allowed as pretty print symbols. Had ' + this.u1a_1;
      throw IllegalArgumentException_init_$Create$(toString(message_2));
    }
  }
  return new JsonConfiguration(this.p1a_1, this.r1a_1, this.s1a_1, this.e1b_1, this.t1a_1, this.q1a_1, this.u1a_1, this.v1a_1, this.f1b_1, this.w1a_1, this.d1b_1, this.y1a_1, this.z1a_1, this.a1b_1, this.b1b_1, this.c1b_1, this.x1a_1);
};
function validateConfiguration($this) {
  if (equals($this.ht(), EmptySerializersModule()))
    return Unit_instance;
  var collector = new JsonSerializersModuleValidator($this.v19_1);
  $this.ht().d19(collector);
}
function JsonImpl(configuration, module_0) {
  Json.call(this, configuration, module_0);
  validateConfiguration(this);
}
function JsonClassDiscriminator() {
}
function JsonIgnoreUnknownKeys() {
}
function JsonNames() {
}
function JsonConfiguration(encodeDefaults, ignoreUnknownKeys, isLenient, allowStructuredMapKeys, prettyPrint, explicitNulls, prettyPrintIndent, coerceInputValues, useArrayPolymorphism, classDiscriminator, allowSpecialFloatingPointValues, useAlternativeNames, namingStrategy, decodeEnumsCaseInsensitive, allowTrailingComma, allowComments, classDiscriminatorMode) {
  encodeDefaults = encodeDefaults === VOID ? false : encodeDefaults;
  ignoreUnknownKeys = ignoreUnknownKeys === VOID ? false : ignoreUnknownKeys;
  isLenient = isLenient === VOID ? false : isLenient;
  allowStructuredMapKeys = allowStructuredMapKeys === VOID ? false : allowStructuredMapKeys;
  prettyPrint = prettyPrint === VOID ? false : prettyPrint;
  explicitNulls = explicitNulls === VOID ? true : explicitNulls;
  prettyPrintIndent = prettyPrintIndent === VOID ? '    ' : prettyPrintIndent;
  coerceInputValues = coerceInputValues === VOID ? false : coerceInputValues;
  useArrayPolymorphism = useArrayPolymorphism === VOID ? false : useArrayPolymorphism;
  classDiscriminator = classDiscriminator === VOID ? 'type' : classDiscriminator;
  allowSpecialFloatingPointValues = allowSpecialFloatingPointValues === VOID ? false : allowSpecialFloatingPointValues;
  useAlternativeNames = useAlternativeNames === VOID ? true : useAlternativeNames;
  namingStrategy = namingStrategy === VOID ? null : namingStrategy;
  decodeEnumsCaseInsensitive = decodeEnumsCaseInsensitive === VOID ? false : decodeEnumsCaseInsensitive;
  allowTrailingComma = allowTrailingComma === VOID ? false : allowTrailingComma;
  allowComments = allowComments === VOID ? false : allowComments;
  classDiscriminatorMode = classDiscriminatorMode === VOID ? ClassDiscriminatorMode_POLYMORPHIC_getInstance() : classDiscriminatorMode;
  this.i1b_1 = encodeDefaults;
  this.j1b_1 = ignoreUnknownKeys;
  this.k1b_1 = isLenient;
  this.l1b_1 = allowStructuredMapKeys;
  this.m1b_1 = prettyPrint;
  this.n1b_1 = explicitNulls;
  this.o1b_1 = prettyPrintIndent;
  this.p1b_1 = coerceInputValues;
  this.q1b_1 = useArrayPolymorphism;
  this.r1b_1 = classDiscriminator;
  this.s1b_1 = allowSpecialFloatingPointValues;
  this.t1b_1 = useAlternativeNames;
  this.u1b_1 = namingStrategy;
  this.v1b_1 = decodeEnumsCaseInsensitive;
  this.w1b_1 = allowTrailingComma;
  this.x1b_1 = allowComments;
  this.y1b_1 = classDiscriminatorMode;
}
protoOf(JsonConfiguration).toString = function () {
  return 'JsonConfiguration(encodeDefaults=' + this.i1b_1 + ', ignoreUnknownKeys=' + this.j1b_1 + ', isLenient=' + this.k1b_1 + ', ' + ('allowStructuredMapKeys=' + this.l1b_1 + ', prettyPrint=' + this.m1b_1 + ', explicitNulls=' + this.n1b_1 + ', ') + ("prettyPrintIndent='" + this.o1b_1 + "', coerceInputValues=" + this.p1b_1 + ', useArrayPolymorphism=' + this.q1b_1 + ', ') + ("classDiscriminator='" + this.r1b_1 + "', allowSpecialFloatingPointValues=" + this.s1b_1 + ', ') + ('useAlternativeNames=' + this.t1b_1 + ', namingStrategy=' + toString_0(this.u1b_1) + ', decodeEnumsCaseInsensitive=' + this.v1b_1 + ', ') + ('allowTrailingComma=' + this.w1b_1 + ', allowComments=' + this.x1b_1 + ', classDiscriminatorMode=' + this.y1b_1.toString() + ')');
};
var ClassDiscriminatorMode_NONE_instance;
var ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance;
var ClassDiscriminatorMode_POLYMORPHIC_instance;
var ClassDiscriminatorMode_entriesInitialized;
function ClassDiscriminatorMode_initEntries() {
  if (ClassDiscriminatorMode_entriesInitialized)
    return Unit_instance;
  ClassDiscriminatorMode_entriesInitialized = true;
  ClassDiscriminatorMode_NONE_instance = new ClassDiscriminatorMode('NONE', 0);
  ClassDiscriminatorMode_ALL_JSON_OBJECTS_instance = new ClassDiscriminatorMode('ALL_JSON_OBJECTS', 1);
  ClassDiscriminatorMode_POLYMORPHIC_instance = new ClassDiscriminatorMode('POLYMORPHIC', 2);
}
function ClassDiscriminatorMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ClassDiscriminatorMode_NONE_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_NONE_instance;
}
function ClassDiscriminatorMode_POLYMORPHIC_getInstance() {
  ClassDiscriminatorMode_initEntries();
  return ClassDiscriminatorMode_POLYMORPHIC_instance;
}
function throwSubtypeNotRegistered($this, subClass, baseClass) {
  var tmp0_elvis_lhs = subClass.ea();
  var subClassName = tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs;
  var scope = "in the scope of '" + baseClass.ea() + "'";
  throw SerializationException_init_$Create$("Class '" + subClassName + "' is not registered for polymorphic serialization " + scope + '.\n' + "Mark the base class as 'sealed' or register the serializer explicitly.");
}
function JsonContentPolymorphicSerializer(baseClass) {
  this.z1b_1 = baseClass;
  this.a1c_1 = buildSerialDescriptor('JsonContentPolymorphicSerializer<' + this.z1b_1.ea() + '>', SEALED_getInstance(), []);
}
protoOf(JsonContentPolymorphicSerializer).fp = function () {
  return this.a1c_1;
};
protoOf(JsonContentPolymorphicSerializer).xp = function (encoder, value) {
  var tmp0_elvis_lhs = encoder.ht().ru(this.z1b_1, value);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? serializerOrNull(getKClassFromExpression(value)) : tmp0_elvis_lhs;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    throwSubtypeNotRegistered(this, getKClassFromExpression(value), this.z1b_1);
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var actualSerializer = tmp;
  (isInterface(actualSerializer, KSerializer) ? actualSerializer : THROW_CCE()).gp(encoder, value);
};
protoOf(JsonContentPolymorphicSerializer).gp = function (encoder, value) {
  return this.xp(encoder, !(value == null) ? value : THROW_CCE());
};
protoOf(JsonContentPolymorphicSerializer).hp = function (decoder) {
  var input = asJsonDecoder(decoder);
  var tree = input.b1c();
  var tmp = this.c1c(tree);
  var actualSerializer = isInterface(tmp, KSerializer) ? tmp : THROW_CCE();
  return input.d1c().y19(actualSerializer, tree);
};
function JsonDecoder() {
}
function get_jsonUnquotedLiteralDescriptor() {
  _init_properties_JsonElement_kt__7cbdc2();
  return jsonUnquotedLiteralDescriptor;
}
var jsonUnquotedLiteralDescriptor;
function Companion() {
}
var Companion_instance;
function Companion_getInstance_3() {
  return Companion_instance;
}
function JsonElement() {
}
function Companion_0() {
}
var Companion_instance_0;
function Companion_getInstance_4() {
  return Companion_instance_0;
}
function JsonObject$toString$lambda(_destruct__k2r9zo) {
  // Inline function 'kotlin.collections.component1' call
  var k = _destruct__k2r9zo.v();
  // Inline function 'kotlin.collections.component2' call
  var v = _destruct__k2r9zo.w();
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  printQuoted(this_0, k);
  this_0.l7(_Char___init__impl__6a9atx(58));
  this_0.j7(v);
  return this_0.toString();
}
function JsonObject(content) {
  JsonElement.call(this);
  this.e1c_1 = content;
}
protoOf(JsonObject).equals = function (other) {
  return equals(this.e1c_1, other);
};
protoOf(JsonObject).hashCode = function () {
  return hashCode(this.e1c_1);
};
protoOf(JsonObject).toString = function () {
  var tmp = this.e1c_1.u();
  return joinToString(tmp, ',', '{', '}', VOID, VOID, JsonObject$toString$lambda);
};
protoOf(JsonObject).q = function () {
  return this.e1c_1.q();
};
protoOf(JsonObject).f1c = function (key) {
  return this.e1c_1.f2(key);
};
protoOf(JsonObject).f2 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return false;
  return this.f1c((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(JsonObject).g1c = function (key) {
  return this.e1c_1.h2(key);
};
protoOf(JsonObject).h2 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return null;
  return this.g1c((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(JsonObject).o = function () {
  return this.e1c_1.o();
};
protoOf(JsonObject).d2 = function () {
  return this.e1c_1.d2();
};
protoOf(JsonObject).e2 = function () {
  return this.e1c_1.e2();
};
protoOf(JsonObject).u = function () {
  return this.e1c_1.u();
};
function get_jsonObject(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonObject ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonObject');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function error(_this__u8e3s4, element) {
  _init_properties_JsonElement_kt__7cbdc2();
  throw IllegalArgumentException_init_$Create$('Element ' + toString(getKClassFromExpression(_this__u8e3s4)) + ' is not a ' + element);
}
function Companion_1() {
}
var Companion_instance_1;
function Companion_getInstance_5() {
  return Companion_instance_1;
}
function JsonPrimitive() {
  JsonElement.call(this);
}
protoOf(JsonPrimitive).toString = function () {
  return this.h1c();
};
function Companion_2() {
}
var Companion_instance_2;
function Companion_getInstance_6() {
  return Companion_instance_2;
}
function JsonArray(content) {
  JsonElement.call(this);
  this.i1c_1 = content;
}
protoOf(JsonArray).equals = function (other) {
  return equals(this.i1c_1, other);
};
protoOf(JsonArray).hashCode = function () {
  return hashCode(this.i1c_1);
};
protoOf(JsonArray).toString = function () {
  return joinToString(this.i1c_1, ',', '[', ']');
};
protoOf(JsonArray).q = function () {
  return this.i1c_1.q();
};
protoOf(JsonArray).j1c = function (element) {
  return this.i1c_1.q1(element);
};
protoOf(JsonArray).q1 = function (element) {
  if (!(element instanceof JsonElement))
    return false;
  return this.j1c(element instanceof JsonElement ? element : THROW_CCE());
};
protoOf(JsonArray).l = function () {
  return this.i1c_1.l();
};
protoOf(JsonArray).k1c = function (elements) {
  return this.i1c_1.r1(elements);
};
protoOf(JsonArray).r1 = function (elements) {
  return this.k1c(elements);
};
protoOf(JsonArray).p = function (index) {
  return this.i1c_1.p(index);
};
protoOf(JsonArray).l1c = function (element) {
  return this.i1c_1.s1(element);
};
protoOf(JsonArray).s1 = function (element) {
  if (!(element instanceof JsonElement))
    return -1;
  return this.l1c(element instanceof JsonElement ? element : THROW_CCE());
};
protoOf(JsonArray).m1c = function (element) {
  return this.i1c_1.t1(element);
};
protoOf(JsonArray).t1 = function (element) {
  if (!(element instanceof JsonElement))
    return -1;
  return this.m1c(element instanceof JsonElement ? element : THROW_CCE());
};
protoOf(JsonArray).u1 = function () {
  return this.i1c_1.u1();
};
protoOf(JsonArray).r = function (index) {
  return this.i1c_1.r(index);
};
protoOf(JsonArray).v1 = function (fromIndex, toIndex) {
  return this.i1c_1.v1(fromIndex, toIndex);
};
protoOf(JsonArray).asJsReadonlyArrayView = function () {
  return this.i1c_1.asJsReadonlyArrayView();
};
protoOf(JsonArray).o = function () {
  return this.i1c_1.o();
};
function JsonNull() {
  JsonNull_instance = this;
  JsonPrimitive.call(this);
  this.n1c_1 = 'null';
}
protoOf(JsonNull).h1c = function () {
  return this.n1c_1;
};
protoOf(JsonNull).o1c = function () {
  return JsonNullSerializer_getInstance();
};
protoOf(JsonNull).k11 = function (typeParamsSerializers) {
  return this.o1c();
};
var JsonNull_instance;
function JsonNull_getInstance() {
  if (JsonNull_instance == null)
    new JsonNull();
  return JsonNull_instance;
}
function JsonLiteral(body, isString, coerceToInlineType) {
  coerceToInlineType = coerceToInlineType === VOID ? null : coerceToInlineType;
  JsonPrimitive.call(this);
  this.p1c_1 = isString;
  this.q1c_1 = coerceToInlineType;
  this.r1c_1 = toString(body);
  if (!(this.q1c_1 == null)) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!this.q1c_1.ar()) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
}
protoOf(JsonLiteral).h1c = function () {
  return this.r1c_1;
};
protoOf(JsonLiteral).toString = function () {
  var tmp;
  if (this.p1c_1) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    printQuoted(this_0, this.r1c_1);
    tmp = this_0.toString();
  } else {
    tmp = this.r1c_1;
  }
  return tmp;
};
protoOf(JsonLiteral).equals = function (other) {
  if (this === other)
    return true;
  if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
    return false;
  if (!(other instanceof JsonLiteral))
    THROW_CCE();
  if (!(this.p1c_1 === other.p1c_1))
    return false;
  if (!(this.r1c_1 === other.r1c_1))
    return false;
  return true;
};
protoOf(JsonLiteral).hashCode = function () {
  var result = getBooleanHashCode(this.p1c_1);
  result = imul(31, result) + getStringHashCode(this.r1c_1) | 0;
  return result;
};
function get_booleanOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toBooleanStrictOrNull_0(_this__u8e3s4.h1c());
}
function parseLongImpl(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return (new StringJsonLexer(_this__u8e3s4.h1c())).s1c();
}
function get_float(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlin.text.toFloat' call
  var this_0 = _this__u8e3s4.h1c();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return toDouble(this_0);
}
function get_double(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  return toDouble(_this__u8e3s4.h1c());
}
function get_contentOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp;
  if (_this__u8e3s4 instanceof JsonNull) {
    tmp = null;
  } else {
    tmp = _this__u8e3s4.h1c();
  }
  return tmp;
}
function JsonPrimitive_0(value) {
  _init_properties_JsonElement_kt__7cbdc2();
  if (value == null)
    return JsonNull_getInstance();
  return new JsonLiteral(value, true);
}
function get_jsonPrimitive(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonPrimitive ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonPrimitive');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_jsonArray(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  var tmp0_elvis_lhs = _this__u8e3s4 instanceof JsonArray ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    error(_this__u8e3s4, 'JsonArray');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function get_intOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.exceptionToNull' call
  var tmp;
  try {
    tmp = parseLongImpl(_this__u8e3s4);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var result = tmp_1;
  // Inline function 'kotlin.ranges.contains' call
  var this_0 = numberRangeToNumber(-2147483648, 2147483647);
  if (!contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result))
    return null;
  return convertToInt(result);
}
function get_longOrNull(_this__u8e3s4) {
  _init_properties_JsonElement_kt__7cbdc2();
  // Inline function 'kotlinx.serialization.json.exceptionToNull' call
  var tmp;
  try {
    tmp = parseLongImpl(_this__u8e3s4);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof JsonDecodingException) {
      var e = $p;
      tmp_0 = null;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
var properties_initialized_JsonElement_kt_abxy8s;
function _init_properties_JsonElement_kt__7cbdc2() {
  if (!properties_initialized_JsonElement_kt_abxy8s) {
    properties_initialized_JsonElement_kt_abxy8s = true;
    jsonUnquotedLiteralDescriptor = InlinePrimitiveDescriptor('kotlinx.serialization.json.JsonUnquotedLiteral', serializer(StringCompanionObject_instance));
  }
}
function JsonElementSerializer$descriptor$lambda($this$buildSerialDescriptor) {
  $this$buildSerialDescriptor.tp('JsonPrimitive', defer(JsonElementSerializer$descriptor$lambda$lambda));
  $this$buildSerialDescriptor.tp('JsonNull', defer(JsonElementSerializer$descriptor$lambda$lambda_0));
  $this$buildSerialDescriptor.tp('JsonLiteral', defer(JsonElementSerializer$descriptor$lambda$lambda_1));
  $this$buildSerialDescriptor.tp('JsonObject', defer(JsonElementSerializer$descriptor$lambda$lambda_2));
  $this$buildSerialDescriptor.tp('JsonArray', defer(JsonElementSerializer$descriptor$lambda$lambda_3));
  return Unit_instance;
}
function JsonElementSerializer$descriptor$lambda$lambda() {
  return JsonPrimitiveSerializer_getInstance().t1c_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_0() {
  return JsonNullSerializer_getInstance().u1c_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_1() {
  return JsonLiteralSerializer_getInstance().v1c_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_2() {
  return JsonObjectSerializer_getInstance().w1c_1;
}
function JsonElementSerializer$descriptor$lambda$lambda_3() {
  return JsonArraySerializer_getInstance().x1c_1;
}
function JsonElementSerializer() {
  JsonElementSerializer_instance = this;
  var tmp = this;
  var tmp_0 = SEALED_getInstance();
  tmp.y1c_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonElement', tmp_0, [], JsonElementSerializer$descriptor$lambda);
}
protoOf(JsonElementSerializer).fp = function () {
  return this.y1c_1;
};
protoOf(JsonElementSerializer).z1c = function (encoder, value) {
  verify(encoder);
  if (value instanceof JsonPrimitive) {
    encoder.ku(JsonPrimitiveSerializer_getInstance(), value);
  } else {
    if (value instanceof JsonObject) {
      encoder.ku(JsonObjectSerializer_getInstance(), value);
    } else {
      if (value instanceof JsonArray) {
        encoder.ku(JsonArraySerializer_getInstance(), value);
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
};
protoOf(JsonElementSerializer).gp = function (encoder, value) {
  return this.z1c(encoder, value instanceof JsonElement ? value : THROW_CCE());
};
protoOf(JsonElementSerializer).hp = function (decoder) {
  var input = asJsonDecoder(decoder);
  return input.b1c();
};
var JsonElementSerializer_instance;
function JsonElementSerializer_getInstance() {
  if (JsonElementSerializer_instance == null)
    new JsonElementSerializer();
  return JsonElementSerializer_instance;
}
function asJsonDecoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonDecoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Decoder to be JsonDecoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function JsonObjectDescriptor() {
  JsonObjectDescriptor_instance = this;
  this.a1d_1 = MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).fp();
  this.b1d_1 = 'kotlinx.serialization.json.JsonObject';
}
protoOf(JsonObjectDescriptor).gq = function () {
  return this.b1d_1;
};
protoOf(JsonObjectDescriptor).dr = function (index) {
  return this.a1d_1.dr(index);
};
protoOf(JsonObjectDescriptor).er = function (name) {
  return this.a1d_1.er(name);
};
protoOf(JsonObjectDescriptor).fr = function (index) {
  return this.a1d_1.fr(index);
};
protoOf(JsonObjectDescriptor).gr = function (index) {
  return this.a1d_1.gr(index);
};
protoOf(JsonObjectDescriptor).hr = function (index) {
  return this.a1d_1.hr(index);
};
protoOf(JsonObjectDescriptor).zq = function () {
  return this.a1d_1.zq();
};
protoOf(JsonObjectDescriptor).sq = function () {
  return this.a1d_1.sq();
};
protoOf(JsonObjectDescriptor).ar = function () {
  return this.a1d_1.ar();
};
protoOf(JsonObjectDescriptor).br = function () {
  return this.a1d_1.br();
};
protoOf(JsonObjectDescriptor).cr = function () {
  return this.a1d_1.cr();
};
var JsonObjectDescriptor_instance;
function JsonObjectDescriptor_getInstance() {
  if (JsonObjectDescriptor_instance == null)
    new JsonObjectDescriptor();
  return JsonObjectDescriptor_instance;
}
function JsonObjectSerializer() {
  JsonObjectSerializer_instance = this;
  this.w1c_1 = JsonObjectDescriptor_getInstance();
}
protoOf(JsonObjectSerializer).fp = function () {
  return this.w1c_1;
};
protoOf(JsonObjectSerializer).c1d = function (encoder, value) {
  verify(encoder);
  MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).gp(encoder, value);
};
protoOf(JsonObjectSerializer).gp = function (encoder, value) {
  return this.c1d(encoder, value instanceof JsonObject ? value : THROW_CCE());
};
protoOf(JsonObjectSerializer).hp = function (decoder) {
  verify_0(decoder);
  return new JsonObject(MapSerializer(serializer(StringCompanionObject_instance), JsonElementSerializer_getInstance()).hp(decoder));
};
var JsonObjectSerializer_instance;
function JsonObjectSerializer_getInstance() {
  if (JsonObjectSerializer_instance == null)
    new JsonObjectSerializer();
  return JsonObjectSerializer_instance;
}
function defer(deferred) {
  return new defer$1(deferred);
}
function JsonPrimitiveSerializer() {
  JsonPrimitiveSerializer_instance = this;
  this.t1c_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonPrimitive', STRING_getInstance(), []);
}
protoOf(JsonPrimitiveSerializer).fp = function () {
  return this.t1c_1;
};
protoOf(JsonPrimitiveSerializer).d1d = function (encoder, value) {
  verify(encoder);
  var tmp;
  if (value instanceof JsonNull) {
    encoder.ku(JsonNullSerializer_getInstance(), JsonNull_getInstance());
    tmp = Unit_instance;
  } else {
    var tmp_0 = JsonLiteralSerializer_getInstance();
    encoder.ku(tmp_0, value instanceof JsonLiteral ? value : THROW_CCE());
    tmp = Unit_instance;
  }
  return tmp;
};
protoOf(JsonPrimitiveSerializer).gp = function (encoder, value) {
  return this.d1d(encoder, value instanceof JsonPrimitive ? value : THROW_CCE());
};
protoOf(JsonPrimitiveSerializer).hp = function (decoder) {
  var result = asJsonDecoder(decoder).b1c();
  if (!(result instanceof JsonPrimitive))
    throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonPrimitive, had ' + toString(getKClassFromExpression(result)), toString(result));
  return result;
};
var JsonPrimitiveSerializer_instance;
function JsonPrimitiveSerializer_getInstance() {
  if (JsonPrimitiveSerializer_instance == null)
    new JsonPrimitiveSerializer();
  return JsonPrimitiveSerializer_instance;
}
function JsonNullSerializer() {
  JsonNullSerializer_instance = this;
  this.u1c_1 = buildSerialDescriptor('kotlinx.serialization.json.JsonNull', ENUM_getInstance(), []);
}
protoOf(JsonNullSerializer).fp = function () {
  return this.u1c_1;
};
protoOf(JsonNullSerializer).e1d = function (encoder, value) {
  verify(encoder);
  encoder.nt();
};
protoOf(JsonNullSerializer).gp = function (encoder, value) {
  return this.e1d(encoder, value instanceof JsonNull ? value : THROW_CCE());
};
protoOf(JsonNullSerializer).hp = function (decoder) {
  verify_0(decoder);
  if (decoder.ds()) {
    throw new JsonDecodingException("Expected 'null' literal");
  }
  decoder.es();
  return JsonNull_getInstance();
};
var JsonNullSerializer_instance;
function JsonNullSerializer_getInstance() {
  if (JsonNullSerializer_instance == null)
    new JsonNullSerializer();
  return JsonNullSerializer_instance;
}
function JsonLiteralSerializer() {
  JsonLiteralSerializer_instance = this;
  this.v1c_1 = PrimitiveSerialDescriptor('kotlinx.serialization.json.JsonLiteral', STRING_getInstance());
}
protoOf(JsonLiteralSerializer).fp = function () {
  return this.v1c_1;
};
protoOf(JsonLiteralSerializer).f1d = function (encoder, value) {
  verify(encoder);
  if (value.p1c_1) {
    return encoder.wt(value.r1c_1);
  }
  if (!(value.q1c_1 == null)) {
    return encoder.yt(value.q1c_1).wt(value.r1c_1);
  }
  var tmp0_safe_receiver = toLongOrNull(value.r1c_1);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.st(tmp0_safe_receiver);
  }
  var tmp1_safe_receiver = toULongOrNull(value.r1c_1);
  var tmp = tmp1_safe_receiver;
  if ((tmp == null ? null : new ULong(tmp)) == null)
    null;
  else {
    var tmp_0 = tmp1_safe_receiver;
    // Inline function 'kotlin.let' call
    var it = (tmp_0 == null ? null : new ULong(tmp_0)).no_1;
    var tmp_1 = encoder.yt(serializer_0(Companion_getInstance()).fp());
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$1 = _ULong___get_data__impl__fggpzb(it);
    tmp_1.st(tmp$ret$1);
    return Unit_instance;
  }
  var tmp2_safe_receiver = toDoubleOrNull(value.r1c_1);
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.ut(tmp2_safe_receiver);
  }
  var tmp3_safe_receiver = toBooleanStrictOrNull(value.r1c_1);
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return encoder.ot(tmp3_safe_receiver);
  }
  encoder.wt(value.r1c_1);
};
protoOf(JsonLiteralSerializer).gp = function (encoder, value) {
  return this.f1d(encoder, value instanceof JsonLiteral ? value : THROW_CCE());
};
protoOf(JsonLiteralSerializer).hp = function (decoder) {
  var result = asJsonDecoder(decoder).b1c();
  if (!(result instanceof JsonLiteral))
    throw JsonDecodingException_0(-1, 'Unexpected JSON element, expected JsonLiteral, had ' + toString(getKClassFromExpression(result)), toString(result));
  return result;
};
var JsonLiteralSerializer_instance;
function JsonLiteralSerializer_getInstance() {
  if (JsonLiteralSerializer_instance == null)
    new JsonLiteralSerializer();
  return JsonLiteralSerializer_instance;
}
function JsonArrayDescriptor() {
  JsonArrayDescriptor_instance = this;
  this.g1d_1 = ListSerializer(JsonElementSerializer_getInstance()).fp();
  this.h1d_1 = 'kotlinx.serialization.json.JsonArray';
}
protoOf(JsonArrayDescriptor).gq = function () {
  return this.h1d_1;
};
protoOf(JsonArrayDescriptor).dr = function (index) {
  return this.g1d_1.dr(index);
};
protoOf(JsonArrayDescriptor).er = function (name) {
  return this.g1d_1.er(name);
};
protoOf(JsonArrayDescriptor).fr = function (index) {
  return this.g1d_1.fr(index);
};
protoOf(JsonArrayDescriptor).gr = function (index) {
  return this.g1d_1.gr(index);
};
protoOf(JsonArrayDescriptor).hr = function (index) {
  return this.g1d_1.hr(index);
};
protoOf(JsonArrayDescriptor).zq = function () {
  return this.g1d_1.zq();
};
protoOf(JsonArrayDescriptor).sq = function () {
  return this.g1d_1.sq();
};
protoOf(JsonArrayDescriptor).ar = function () {
  return this.g1d_1.ar();
};
protoOf(JsonArrayDescriptor).br = function () {
  return this.g1d_1.br();
};
protoOf(JsonArrayDescriptor).cr = function () {
  return this.g1d_1.cr();
};
var JsonArrayDescriptor_instance;
function JsonArrayDescriptor_getInstance() {
  if (JsonArrayDescriptor_instance == null)
    new JsonArrayDescriptor();
  return JsonArrayDescriptor_instance;
}
function JsonArraySerializer() {
  JsonArraySerializer_instance = this;
  this.x1c_1 = JsonArrayDescriptor_getInstance();
}
protoOf(JsonArraySerializer).fp = function () {
  return this.x1c_1;
};
protoOf(JsonArraySerializer).i1d = function (encoder, value) {
  verify(encoder);
  ListSerializer(JsonElementSerializer_getInstance()).gp(encoder, value);
};
protoOf(JsonArraySerializer).gp = function (encoder, value) {
  return this.i1d(encoder, value instanceof JsonArray ? value : THROW_CCE());
};
protoOf(JsonArraySerializer).hp = function (decoder) {
  verify_0(decoder);
  return new JsonArray(ListSerializer(JsonElementSerializer_getInstance()).hp(decoder));
};
var JsonArraySerializer_instance;
function JsonArraySerializer_getInstance() {
  if (JsonArraySerializer_instance == null)
    new JsonArraySerializer();
  return JsonArraySerializer_instance;
}
function verify(encoder) {
  asJsonEncoder(encoder);
}
function verify_0(decoder) {
  asJsonDecoder(decoder);
}
function asJsonEncoder(_this__u8e3s4) {
  var tmp0_elvis_lhs = isInterface(_this__u8e3s4, JsonEncoder) ? _this__u8e3s4 : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('This serializer can be used only with Json format.' + ('Expected Encoder to be JsonEncoder, got ' + toString(getKClassFromExpression(_this__u8e3s4))));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.j1d_1;
  var tmp = KProperty1;
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, defer$o$_get_original_$ref_3cje7k(), null);
  return tmp0.w();
}
function defer$o$_get_original_$ref_3cje7k() {
  return function (p0) {
    return _get_original__l7ku1m(p0);
  };
}
function defer$1($deferred) {
  this.j1d_1 = lazy($deferred);
}
protoOf(defer$1).gq = function () {
  return _get_original__l7ku1m(this).gq();
};
protoOf(defer$1).zq = function () {
  return _get_original__l7ku1m(this).zq();
};
protoOf(defer$1).br = function () {
  return _get_original__l7ku1m(this).br();
};
protoOf(defer$1).dr = function (index) {
  return _get_original__l7ku1m(this).dr(index);
};
protoOf(defer$1).er = function (name) {
  return _get_original__l7ku1m(this).er(name);
};
protoOf(defer$1).fr = function (index) {
  return _get_original__l7ku1m(this).fr(index);
};
protoOf(defer$1).gr = function (index) {
  return _get_original__l7ku1m(this).gr(index);
};
protoOf(defer$1).hr = function (index) {
  return _get_original__l7ku1m(this).hr(index);
};
function JsonEncoder() {
}
function Composer(writer) {
  this.k1d_1 = writer;
  this.l1d_1 = true;
}
protoOf(Composer).m1d = function () {
  this.l1d_1 = true;
};
protoOf(Composer).n1d = function () {
  return Unit_instance;
};
protoOf(Composer).o1d = function () {
  this.l1d_1 = false;
};
protoOf(Composer).p1d = function () {
  this.l1d_1 = false;
};
protoOf(Composer).q1d = function () {
  return Unit_instance;
};
protoOf(Composer).r1d = function (v) {
  return this.k1d_1.s1d(v);
};
protoOf(Composer).t1d = function (v) {
  return this.k1d_1.u1d(v);
};
protoOf(Composer).v1d = function (v) {
  return this.k1d_1.u1d(v.toString());
};
protoOf(Composer).w1d = function (v) {
  return this.k1d_1.u1d(v.toString());
};
protoOf(Composer).x1d = function (v) {
  return this.k1d_1.y1d(fromInt(v));
};
protoOf(Composer).z1d = function (v) {
  return this.k1d_1.y1d(fromInt(v));
};
protoOf(Composer).a1e = function (v) {
  return this.k1d_1.y1d(fromInt(v));
};
protoOf(Composer).b1e = function (v) {
  return this.k1d_1.y1d(v);
};
protoOf(Composer).c1e = function (v) {
  return this.k1d_1.u1d(v.toString());
};
protoOf(Composer).d1e = function (value) {
  return this.k1d_1.e1e(value);
};
function Composer_0(sb, json) {
  return json.v19_1.m1b_1 ? new ComposerWithPrettyPrint(sb, json) : new Composer(sb);
}
function ComposerForUnsignedNumbers(writer, forceQuoting) {
  Composer.call(this, writer);
  this.h1e_1 = forceQuoting;
}
protoOf(ComposerForUnsignedNumbers).a1e = function (v) {
  if (this.h1e_1) {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(v);
    this.d1e(UInt__toString_impl_dbgl21(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUInt' call
    var tmp$ret$1 = _UInt___init__impl__l7qpdl(v);
    this.t1d(UInt__toString_impl_dbgl21(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).b1e = function (v) {
  if (this.h1e_1) {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$0 = _ULong___init__impl__c78o9k(v);
    this.d1e(ULong__toString_impl_f9au7k(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toULong' call
    var tmp$ret$1 = _ULong___init__impl__c78o9k(v);
    this.t1d(ULong__toString_impl_f9au7k(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).x1d = function (v) {
  if (this.h1e_1) {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(v);
    this.d1e(UByte__toString_impl_v72jg(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUByte' call
    var tmp$ret$1 = _UByte___init__impl__g9hnc4(v);
    this.t1d(UByte__toString_impl_v72jg(tmp$ret$1));
  }
};
protoOf(ComposerForUnsignedNumbers).z1d = function (v) {
  if (this.h1e_1) {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$0 = _UShort___init__impl__jigrne(v);
    this.d1e(UShort__toString_impl_edaoee(tmp$ret$0));
  } else {
    // Inline function 'kotlin.toUShort' call
    var tmp$ret$1 = _UShort___init__impl__jigrne(v);
    this.t1d(UShort__toString_impl_edaoee(tmp$ret$1));
  }
};
function ComposerForUnquotedLiterals(writer, forceQuoting) {
  Composer.call(this, writer);
  this.k1e_1 = forceQuoting;
}
protoOf(ComposerForUnquotedLiterals).d1e = function (value) {
  if (this.k1e_1) {
    protoOf(Composer).d1e.call(this, value);
  } else {
    protoOf(Composer).t1d.call(this, value);
  }
};
function ComposerWithPrettyPrint(writer, json) {
  Composer.call(this, writer);
  this.n1e_1 = json;
  this.o1e_1 = 0;
}
protoOf(ComposerWithPrettyPrint).m1d = function () {
  this.l1d_1 = true;
  this.o1e_1 = this.o1e_1 + 1 | 0;
};
protoOf(ComposerWithPrettyPrint).n1d = function () {
  this.o1e_1 = this.o1e_1 - 1 | 0;
};
protoOf(ComposerWithPrettyPrint).o1d = function () {
  this.l1d_1 = false;
  this.t1d('\n');
  // Inline function 'kotlin.repeat' call
  var times = this.o1e_1;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      this.t1d(this.n1e_1.v19_1.o1b_1);
    }
     while (inductionVariable < times);
};
protoOf(ComposerWithPrettyPrint).p1d = function () {
  if (this.l1d_1)
    this.l1d_1 = false;
  else {
    this.o1d();
  }
};
protoOf(ComposerWithPrettyPrint).q1d = function () {
  this.r1d(_Char___init__impl__6a9atx(32));
};
function readIfAbsent($this, descriptor, index) {
  $this.q1e_1 = (!descriptor.hr(index) && descriptor.gr(index).sq());
  return $this.q1e_1;
}
function JsonElementMarker$readIfAbsent$ref(p0) {
  var l = function (_this__u8e3s4, p0_0) {
    var tmp0 = p0;
    return readIfAbsent(tmp0, _this__u8e3s4, p0_0);
  };
  l.callableName = 'readIfAbsent';
  return l;
}
function JsonElementMarker(descriptor) {
  var tmp = this;
  tmp.p1e_1 = new ElementMarker(descriptor, JsonElementMarker$readIfAbsent$ref(this));
  this.q1e_1 = false;
}
protoOf(JsonElementMarker).r1e = function (index) {
  this.p1e_1.az(index);
};
protoOf(JsonElementMarker).s1e = function () {
  return this.p1e_1.bz();
};
function JsonDecodingException(message) {
  JsonException.call(this, message);
  captureStack(this, JsonDecodingException);
}
function JsonDecodingException_0(offset, message, input) {
  return JsonDecodingException_1(offset, message + '\nJSON input: ' + toString(minify(input, offset)));
}
function JsonException(message) {
  SerializationException_init_$Init$(message, this);
  captureStack(this, JsonException);
}
function JsonDecodingException_1(offset, message) {
  return new JsonDecodingException(offset >= 0 ? 'Unexpected JSON token at offset ' + offset + ': ' + message : message);
}
function minify(_this__u8e3s4, offset) {
  offset = offset === VOID ? -1 : offset;
  if (charSequenceLength(_this__u8e3s4) < 200)
    return _this__u8e3s4;
  if (offset === -1) {
    var start = charSequenceLength(_this__u8e3s4) - 60 | 0;
    if (start <= 0)
      return _this__u8e3s4;
    // Inline function 'kotlin.text.substring' call
    var endIndex = charSequenceLength(_this__u8e3s4);
    return '.....' + toString(charSequenceSubSequence(_this__u8e3s4, start, endIndex));
  }
  var start_0 = offset - 30 | 0;
  var end = offset + 30 | 0;
  var prefix = start_0 <= 0 ? '' : '.....';
  var suffix = end >= charSequenceLength(_this__u8e3s4) ? '' : '.....';
  var tmp2 = coerceAtLeast(start_0, 0);
  // Inline function 'kotlin.text.substring' call
  var endIndex_0 = coerceAtMost(end, charSequenceLength(_this__u8e3s4));
  return prefix + toString(charSequenceSubSequence(_this__u8e3s4, tmp2, endIndex_0)) + suffix;
}
function invalidTrailingComma(_this__u8e3s4, entity) {
  entity = entity === VOID ? 'object' : entity;
  _this__u8e3s4.t1e('Trailing comma before the end of JSON ' + entity, _this__u8e3s4.k1a_1 - 1 | 0, "Trailing commas are non-complaint JSON and not allowed by default. Use 'allowTrailingComma = true' in 'Json {}' builder to support them.");
}
function throwInvalidFloatingPointDecoded(_this__u8e3s4, result) {
  _this__u8e3s4.u1e('Unexpected special floating-point value ' + toString(result) + '. By default, ' + 'non-finite floating point values are prohibited because they do not conform JSON specification', VOID, "It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'");
}
function JsonEncodingException(message) {
  JsonException.call(this, message);
  captureStack(this, JsonEncodingException);
}
function InvalidFloatingPointEncoded(value, output) {
  return new JsonEncodingException('Unexpected special floating-point value ' + toString(value) + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output))));
}
function InvalidFloatingPointDecoded(value, key, output) {
  return JsonDecodingException_1(-1, unexpectedFpErrorMessage(value, key, output));
}
function InvalidKeyKindException(keyDescriptor) {
  return new JsonEncodingException("Value of type '" + keyDescriptor.gq() + "' can't be used in JSON as a key in the map. " + ("It should have either primitive or enum kind, but its kind is '" + keyDescriptor.zq().toString() + "'.\n") + "Use 'allowStructuredMapKeys = true' in 'Json {}' builder to convert such maps to [key1, value1, key2, value2,...] arrays.");
}
function unexpectedFpErrorMessage(value, key, output) {
  return 'Unexpected special floating-point value ' + toString(value) + ' with key ' + key + '. By default, ' + "non-finite floating point values are prohibited because they do not conform JSON specification. It is possible to deserialize them using 'JsonBuilder.allowSpecialFloatingPointValues = true'\n" + ('Current output: ' + toString(minify(output)));
}
function get_JsonDeserializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonDeserializationNamesKey;
}
var JsonDeserializationNamesKey;
function get_JsonSerializationNamesKey() {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return JsonSerializationNamesKey;
}
var JsonSerializationNamesKey;
function ignoreUnknownKeys(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp;
  if (json.v19_1.j1b_1) {
    tmp = true;
  } else {
    var tmp0 = _this__u8e3s4.cr();
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.q();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.l();
      while (_iterator__ex2g4s.m()) {
        var element = _iterator__ex2g4s.n();
        if (element instanceof JsonIgnoreUnknownKeys) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function getJsonNameIndex(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  if (decodeCaseInsensitive(json, _this__u8e3s4)) {
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = name.toLowerCase();
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, tmp$ret$1);
  }
  var strategy = namingStrategy(_this__u8e3s4, json);
  if (!(strategy == null))
    return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
  var index = _this__u8e3s4.er(name);
  if (!(index === -3))
    return index;
  if (!json.v19_1.t1b_1)
    return index;
  return getJsonNameIndexSlowPath(_this__u8e3s4, json, name);
}
function getJsonNameIndexOrThrow(_this__u8e3s4, json, name, suffix) {
  suffix = suffix === VOID ? '' : suffix;
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var index = getJsonNameIndex(_this__u8e3s4, json, name);
  if (index === -3)
    throw SerializationException_init_$Create$(_this__u8e3s4.gq() + " does not contain element with name '" + name + "'" + suffix);
  return index;
}
function getJsonElementName(_this__u8e3s4, json, index) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var strategy = namingStrategy(_this__u8e3s4, json);
  return strategy == null ? _this__u8e3s4.dr(index) : serializationNamesIndices(_this__u8e3s4, json, strategy)[index];
}
function namingStrategy(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return equals(_this__u8e3s4.zq(), CLASS_getInstance()) ? json.v19_1.u1b_1 : null;
}
function deserializationNamesMap(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(_this__u8e3s4);
  var tmp_0 = get_JsonDeserializationNamesKey();
  return tmp.w1e(descriptor, tmp_0, deserializationNamesMap$lambda(descriptor, _this__u8e3s4));
}
function decodeCaseInsensitive(_this__u8e3s4, descriptor) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  return _this__u8e3s4.v19_1.v1b_1 && equals(descriptor.zq(), ENUM_getInstance());
}
function getJsonNameIndexSlowPath(_this__u8e3s4, json, name) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp0_elvis_lhs = deserializationNamesMap(json, _this__u8e3s4).h2(name);
  return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
}
function serializationNamesIndices(_this__u8e3s4, json, strategy) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  var tmp = get_schemaCache(json);
  var tmp_0 = get_JsonSerializationNamesKey();
  return tmp.w1e(_this__u8e3s4, tmp_0, serializationNamesIndices$lambda(_this__u8e3s4, strategy));
}
function buildDeserializationNamesMap(_this__u8e3s4, json) {
  _init_properties_JsonNamesMap_kt__cbbp0k();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var builder = LinkedHashMap_init_$Create$();
  var useLowercaseEnums = decodeCaseInsensitive(json, _this__u8e3s4);
  var strategyForClasses = namingStrategy(_this__u8e3s4, json);
  var inductionVariable = 0;
  var last = _this__u8e3s4.br();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.collections.filterIsInstance' call
      var tmp0 = _this__u8e3s4.fr(i);
      // Inline function 'kotlin.collections.filterIsInstanceTo' call
      var destination = ArrayList_init_$Create$();
      var _iterator__ex2g4s = tmp0.l();
      while (_iterator__ex2g4s.m()) {
        var element = _iterator__ex2g4s.n();
        if (element instanceof JsonNames) {
          destination.j(element);
        }
      }
      var tmp0_safe_receiver = singleOrNull(destination);
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x1e_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_0 = 0;
        var last_0 = tmp1_safe_receiver.length;
        while (inductionVariable_0 < last_0) {
          var element_0 = tmp1_safe_receiver[inductionVariable_0];
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp;
          if (useLowercaseEnums) {
            // Inline function 'kotlin.text.lowercase' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp = element_0.toLowerCase();
          } else {
            tmp = element_0;
          }
          buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, tmp, i);
        }
      }
      var tmp_0;
      if (useLowercaseEnums) {
        // Inline function 'kotlin.text.lowercase' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_0 = _this__u8e3s4.dr(i).toLowerCase();
      } else if (!(strategyForClasses == null)) {
        tmp_0 = strategyForClasses.y1e(_this__u8e3s4, i, _this__u8e3s4.dr(i));
      } else {
        tmp_0 = null;
      }
      var nameToPut = tmp_0;
      if (nameToPut == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        buildDeserializationNamesMap$putOrThrow(builder, _this__u8e3s4, nameToPut, i);
      }
    }
     while (inductionVariable < last);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_1;
  if (builder.q()) {
    tmp_1 = emptyMap();
  } else {
    tmp_1 = builder;
  }
  return tmp_1;
}
function buildDeserializationNamesMap$putOrThrow(_this__u8e3s4, $this_buildDeserializationNamesMap, name, index) {
  var entity = equals($this_buildDeserializationNamesMap.zq(), ENUM_getInstance()) ? 'enum value' : 'property';
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  if ((isInterface(_this__u8e3s4, KtMap) ? _this__u8e3s4 : THROW_CCE()).f2(name)) {
    throw new JsonException("The suggested name '" + name + "' for " + entity + ' ' + $this_buildDeserializationNamesMap.dr(index) + ' is already one of the names for ' + entity + ' ' + ($this_buildDeserializationNamesMap.dr(getValue(_this__u8e3s4, name)) + ' in ' + toString($this_buildDeserializationNamesMap)));
  }
  // Inline function 'kotlin.collections.set' call
  _this__u8e3s4.a2(name, index);
}
function deserializationNamesMap$lambda($descriptor, $this_deserializationNamesMap) {
  return function () {
    return buildDeserializationNamesMap($descriptor, $this_deserializationNamesMap);
  };
}
function serializationNamesIndices$lambda($this_serializationNamesIndices, $strategy) {
  return function () {
    var tmp = 0;
    var tmp_0 = $this_serializationNamesIndices.br();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var baseName = $this_serializationNamesIndices.dr(tmp_2);
      tmp_1[tmp_2] = $strategy.y1e($this_serializationNamesIndices, tmp_2, baseName);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
var properties_initialized_JsonNamesMap_kt_ljpf42;
function _init_properties_JsonNamesMap_kt__cbbp0k() {
  if (!properties_initialized_JsonNamesMap_kt_ljpf42) {
    properties_initialized_JsonNamesMap_kt_ljpf42 = true;
    JsonDeserializationNamesKey = new Key();
    JsonSerializationNamesKey = new Key();
  }
}
function Tombstone() {
}
var Tombstone_instance;
function Tombstone_getInstance() {
  return Tombstone_instance;
}
function resize($this) {
  var newSize = imul($this.b1f_1, 2);
  $this.z1e_1 = copyOf($this.z1e_1, newSize);
  var tmp = 0;
  var tmp_0 = new Int32Array(newSize);
  while (tmp < newSize) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var newIndices = tmp_0;
  // Inline function 'kotlin.collections.copyInto' call
  var this_0 = $this.a1f_1;
  var endIndex = this_0.length;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_1 = this_0;
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  arrayCopy(tmp_1, newIndices, 0, 0, endIndex);
  $this.a1f_1 = newIndices;
}
function JsonPath() {
  var tmp = this;
  // Inline function 'kotlin.arrayOfNulls' call
  tmp.z1e_1 = Array(8);
  var tmp_0 = this;
  var tmp_1 = 0;
  var tmp_2 = new Int32Array(8);
  while (tmp_1 < 8) {
    tmp_2[tmp_1] = -1;
    tmp_1 = tmp_1 + 1 | 0;
  }
  tmp_0.a1f_1 = tmp_2;
  this.b1f_1 = -1;
}
protoOf(JsonPath).c1f = function (sd) {
  this.b1f_1 = this.b1f_1 + 1 | 0;
  var depth = this.b1f_1;
  if (depth === this.z1e_1.length) {
    resize(this);
  }
  this.z1e_1[depth] = sd;
};
protoOf(JsonPath).d1f = function (index) {
  this.a1f_1[this.b1f_1] = index;
};
protoOf(JsonPath).e1f = function (key) {
  var tmp;
  if (!(this.a1f_1[this.b1f_1] === -2)) {
    this.b1f_1 = this.b1f_1 + 1 | 0;
    tmp = this.b1f_1 === this.z1e_1.length;
  } else {
    tmp = false;
  }
  if (tmp) {
    resize(this);
  }
  this.z1e_1[this.b1f_1] = key;
  this.a1f_1[this.b1f_1] = -2;
};
protoOf(JsonPath).f1f = function () {
  if (this.a1f_1[this.b1f_1] === -2) {
    this.z1e_1[this.b1f_1] = Tombstone_instance;
  }
};
protoOf(JsonPath).g1f = function () {
  var depth = this.b1f_1;
  if (this.a1f_1[depth] === -2) {
    this.a1f_1[depth] = -1;
    this.b1f_1 = this.b1f_1 - 1 | 0;
  }
  if (!(this.b1f_1 === -1)) {
    this.b1f_1 = this.b1f_1 - 1 | 0;
  }
};
protoOf(JsonPath).h1f = function () {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$();
  this_0.k7('$');
  // Inline function 'kotlin.repeat' call
  var times = this.b1f_1 + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < times)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var element = this.z1e_1[index];
      if (!(element == null) ? isInterface(element, SerialDescriptor) : false) {
        if (equals(element.zq(), LIST_getInstance())) {
          if (!(this.a1f_1[index] === -1)) {
            this_0.k7('[');
            this_0.yb(this.a1f_1[index]);
            this_0.k7(']');
          }
        } else {
          var idx = this.a1f_1[index];
          if (idx >= 0) {
            this_0.k7('.');
            this_0.k7(element.dr(idx));
          }
        }
      } else {
        if (!(element === Tombstone_instance)) {
          this_0.k7('[');
          this_0.k7("'");
          this_0.j7(element);
          this_0.k7("'");
          this_0.k7(']');
        }
      }
    }
     while (inductionVariable < times);
  return this_0.toString();
};
protoOf(JsonPath).toString = function () {
  return this.h1f();
};
function checkKind($this, descriptor, actualClass) {
  var kind = descriptor.zq();
  var tmp;
  if (kind instanceof PolymorphicKind) {
    tmp = true;
  } else {
    tmp = equals(kind, CONTEXTUAL_getInstance());
  }
  if (tmp) {
    throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.ea() + " can't be registered as a subclass for polymorphic serialization " + ('because its kind ' + kind.toString() + ' is not concrete. To work with multiple hierarchies, register it as a base class.'));
  }
  if ($this.j1f_1)
    return Unit_instance;
  if (!$this.k1f_1)
    return Unit_instance;
  var tmp_0;
  var tmp_1;
  if (equals(kind, LIST_getInstance()) || equals(kind, MAP_getInstance())) {
    tmp_1 = true;
  } else {
    tmp_1 = kind instanceof PrimitiveKind;
  }
  if (tmp_1) {
    tmp_0 = true;
  } else {
    tmp_0 = kind instanceof ENUM;
  }
  if (tmp_0) {
    throw IllegalArgumentException_init_$Create$('Serializer for ' + actualClass.ea() + ' of kind ' + kind.toString() + ' cannot be serialized polymorphically with class discriminator.');
  }
}
function checkDiscriminatorCollisions($this, descriptor, actualClass) {
  var inductionVariable = 0;
  var last = descriptor.br();
  if (inductionVariable < last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var name = descriptor.dr(i);
      if (name === $this.i1f_1) {
        throw IllegalArgumentException_init_$Create$('Polymorphic serializer for ' + toString(actualClass) + " has property '" + name + "' that conflicts " + 'with JSON class discriminator. You can either change class discriminator in JsonConfiguration, rename property with @SerialName annotation or fall back to array polymorphism');
      }
    }
     while (inductionVariable < last);
}
function JsonSerializersModuleValidator(configuration) {
  this.i1f_1 = configuration.r1b_1;
  this.j1f_1 = configuration.q1b_1;
  this.k1f_1 = !configuration.y1b_1.equals(ClassDiscriminatorMode_NONE_getInstance());
}
protoOf(JsonSerializersModuleValidator).m19 = function (kClass, provider) {
};
protoOf(JsonSerializersModuleValidator).p19 = function (baseClass, actualClass, actualSerializer) {
  var descriptor = actualSerializer.fp();
  checkKind(this, descriptor, actualClass);
  if (!this.j1f_1 && this.k1f_1) {
    checkDiscriminatorCollisions(this, descriptor, actualClass);
  }
};
protoOf(JsonSerializersModuleValidator).q19 = function (baseClass, defaultSerializerProvider) {
};
protoOf(JsonSerializersModuleValidator).r19 = function (baseClass, defaultDeserializerProvider) {
};
function encodeByWriter(json, writer, serializer, value) {
  var tmp = WriteMode_OBJ_getInstance();
  // Inline function 'kotlin.arrayOfNulls' call
  var size = get_entries().o();
  var tmp$ret$0 = Array(size);
  var encoder = StreamingJsonEncoder_init_$Create$(writer, json, tmp, tmp$ret$0);
  encoder.ku(serializer, value);
}
function readObject($this) {
  // Inline function 'kotlinx.serialization.json.internal.JsonTreeReader.readObjectImpl' call
  var lastToken = $this.u1f_1.y1f(6);
  if ($this.u1f_1.z1f() === 4) {
    $this.u1f_1.u1e('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.linkedMapOf' call
  var result = LinkedHashMap_init_$Create$();
  $l$loop: while ($this.u1f_1.a1g()) {
    var key = $this.v1f_1 ? $this.u1f_1.c1g() : $this.u1f_1.b1g();
    $this.u1f_1.y1f(5);
    var element = $this.d1g();
    // Inline function 'kotlin.collections.set' call
    result.a2(key, element);
    lastToken = $this.u1f_1.e1g();
    var tmp0_subject = lastToken;
    if (tmp0_subject !== 4)
      if (tmp0_subject === 7)
        break $l$loop;
      else {
        $this.u1f_1.u1e('Expected end of the object or comma');
      }
  }
  if (lastToken === 6) {
    $this.u1f_1.y1f(7);
  } else if (lastToken === 4) {
    if (!$this.w1f_1) {
      invalidTrailingComma($this.u1f_1);
    }
    $this.u1f_1.y1f(7);
  }
  return new JsonObject(result);
}
function readObject_0($this, _this__u8e3s4, $completion) {
  var tmp = new $readObjectCOROUTINE$($this, _this__u8e3s4, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
}
function readArray($this) {
  var lastToken = $this.u1f_1.e1g();
  if ($this.u1f_1.z1f() === 4) {
    $this.u1f_1.u1e('Unexpected leading comma');
  }
  // Inline function 'kotlin.collections.arrayListOf' call
  var result = ArrayList_init_$Create$();
  while ($this.u1f_1.a1g()) {
    var element = $this.d1g();
    result.j(element);
    lastToken = $this.u1f_1.e1g();
    if (!(lastToken === 4)) {
      var tmp0 = $this.u1f_1;
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
      var condition = lastToken === 9;
      var position = tmp0.k1a_1;
      if (!condition) {
        var tmp$ret$1 = 'Expected end of the array or comma';
        tmp0.u1e(tmp$ret$1, position);
      }
    }
  }
  if (lastToken === 8) {
    $this.u1f_1.y1f(9);
  } else if (lastToken === 4) {
    if (!$this.w1f_1) {
      invalidTrailingComma($this.u1f_1, 'array');
    }
    $this.u1f_1.y1f(9);
  }
  return new JsonArray(result);
}
function readValue($this, isString) {
  var tmp;
  if ($this.v1f_1 || !isString) {
    tmp = $this.u1f_1.c1g();
  } else {
    tmp = $this.u1f_1.b1g();
  }
  var string = tmp;
  if (!isString && string === 'null')
    return JsonNull_getInstance();
  return new JsonLiteral(string, isString);
}
function readDeepRecursive($this) {
  return invoke(new DeepRecursiveFunction(JsonTreeReader$readDeepRecursive$slambda_0($this, null)), Unit_instance);
}
function JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation) {
  this.b1h_1 = this$0;
  CoroutineImpl.call(this, resultContinuation);
}
protoOf(JsonTreeReader$readDeepRecursive$slambda).f1h = function ($this$DeepRecursiveFunction, it, $completion) {
  var tmp = this.g1h($this$DeepRecursiveFunction, it, $completion);
  tmp.f8_1 = Unit_instance;
  tmp.g8_1 = null;
  return tmp.l8();
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).y8 = function (p1, p2, $completion) {
  var tmp = p1 instanceof DeepRecursiveScope ? p1 : THROW_CCE();
  return this.f1h(tmp, p2 instanceof Unit ? p2 : THROW_CCE(), $completion);
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 3;
          var tmp0_subject = this.b1h_1.u1f_1.z1f();
          if (tmp0_subject === 1) {
            this.e1h_1 = readValue(this.b1h_1, true);
            this.d8_1 = 2;
            continue $sm;
          } else {
            if (tmp0_subject === 0) {
              this.e1h_1 = readValue(this.b1h_1, false);
              this.d8_1 = 2;
              continue $sm;
            } else {
              if (tmp0_subject === 6) {
                this.d8_1 = 1;
                suspendResult = readObject_0(this.b1h_1, this.c1h_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject === 8) {
                  this.e1h_1 = readArray(this.b1h_1);
                  this.d8_1 = 2;
                  continue $sm;
                } else {
                  var tmp_0 = this;
                  this.b1h_1.u1f_1.u1e("Can't begin reading element, unexpected token");
                }
              }
            }
          }

          break;
        case 1:
          this.e1h_1 = suspendResult;
          this.d8_1 = 2;
          continue $sm;
        case 2:
          return this.e1h_1;
        case 3:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 3) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
protoOf(JsonTreeReader$readDeepRecursive$slambda).g1h = function ($this$DeepRecursiveFunction, it, completion) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this.b1h_1, completion);
  i.c1h_1 = $this$DeepRecursiveFunction;
  i.d1h_1 = it;
  return i;
};
function JsonTreeReader$readDeepRecursive$slambda_0(this$0, resultContinuation) {
  var i = new JsonTreeReader$readDeepRecursive$slambda(this$0, resultContinuation);
  var l = function ($this$DeepRecursiveFunction, it, $completion) {
    return i.f1h($this$DeepRecursiveFunction, it, $completion);
  };
  l.$arity = 2;
  return l;
}
function $readObjectCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.n1g_1 = _this__u8e3s4;
  this.o1g_1 = _this__u8e3s4_0;
}
protoOf($readObjectCOROUTINE$).l8 = function () {
  var suspendResult = this.f8_1;
  $sm: do
    try {
      var tmp = this.d8_1;
      switch (tmp) {
        case 0:
          this.e8_1 = 5;
          this.q1g_1 = this.n1g_1;
          this.r1g_1 = this.q1g_1.u1f_1.y1f(6);
          if (this.q1g_1.u1f_1.z1f() === 4) {
            this.q1g_1.u1f_1.u1e('Unexpected leading comma');
          }

          var tmp_0 = this;
          tmp_0.p1g_1 = LinkedHashMap_init_$Create$();
          this.d8_1 = 1;
          continue $sm;
        case 1:
          if (!this.q1g_1.u1f_1.a1g()) {
            this.d8_1 = 4;
            continue $sm;
          }

          this.s1g_1 = this.q1g_1.v1f_1 ? this.q1g_1.u1f_1.c1g() : this.q1g_1.u1f_1.b1g();
          this.q1g_1.u1f_1.y1f(5);
          this.d8_1 = 2;
          suspendResult = this.o1g_1.rm(Unit_instance, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 2:
          var element = suspendResult;
          var tmp0 = this.p1g_1;
          var key = this.s1g_1;
          tmp0.a2(key, element);
          this.r1g_1 = this.q1g_1.u1f_1.e1g();
          var tmp0_subject = this.r1g_1;
          if (tmp0_subject === 4) {
            this.d8_1 = 3;
            continue $sm;
          } else {
            if (tmp0_subject === 7) {
              this.d8_1 = 4;
              continue $sm;
            } else {
              this.q1g_1.u1f_1.u1e('Expected end of the object or comma');
            }
          }

          break;
        case 3:
          this.d8_1 = 1;
          continue $sm;
        case 4:
          if (this.r1g_1 === 6) {
            this.q1g_1.u1f_1.y1f(7);
          } else if (this.r1g_1 === 4) {
            if (!this.q1g_1.w1f_1) {
              invalidTrailingComma(this.q1g_1.u1f_1);
            }
            this.q1g_1.u1f_1.y1f(7);
          }

          return new JsonObject(this.p1g_1);
        case 5:
          throw this.g8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.e8_1 === 5) {
        throw e;
      } else {
        this.d8_1 = this.e8_1;
        this.g8_1 = e;
      }
    }
   while (true);
};
function JsonTreeReader(configuration, lexer) {
  this.u1f_1 = lexer;
  this.v1f_1 = configuration.k1b_1;
  this.w1f_1 = configuration.w1b_1;
  this.x1f_1 = 0;
}
protoOf(JsonTreeReader).d1g = function () {
  var token = this.u1f_1.z1f();
  var tmp;
  if (token === 1) {
    tmp = readValue(this, true);
  } else if (token === 0) {
    tmp = readValue(this, false);
  } else if (token === 6) {
    var tmp_0;
    this.x1f_1 = this.x1f_1 + 1 | 0;
    if (this.x1f_1 === 200) {
      tmp_0 = readDeepRecursive(this);
    } else {
      tmp_0 = readObject(this);
    }
    var result = tmp_0;
    this.x1f_1 = this.x1f_1 - 1 | 0;
    tmp = result;
  } else if (token === 8) {
    tmp = readArray(this);
  } else {
    this.u1f_1.u1e('Cannot read Json element because of unexpected ' + tokenDescription(token));
  }
  return tmp;
};
function classDiscriminator(_this__u8e3s4, json) {
  var _iterator__ex2g4s = _this__u8e3s4.cr().l();
  while (_iterator__ex2g4s.m()) {
    var annotation = _iterator__ex2g4s.n();
    if (annotation instanceof JsonClassDiscriminator)
      return annotation.h1h_1;
  }
  return json.v19_1.r1b_1;
}
function validateIfSealed(serializer, actualSerializer, classDiscriminator) {
  if (!(serializer instanceof SealedClassSerializer))
    return Unit_instance;
  if (jsonCachedSerialNames(actualSerializer.fp()).q1(classDiscriminator)) {
    var baseName = serializer.fp().gq();
    var actualName = actualSerializer.fp().gq();
    // Inline function 'kotlin.error' call
    var message = "Sealed class '" + actualName + "' cannot be serialized as base class '" + baseName + "' because" + (" it has property name that conflicts with JSON class discriminator '" + classDiscriminator + "'. ") + 'You can either change class discriminator in JsonConfiguration, rename property with @SerialName annotation or fall back to array polymorphism';
    throw IllegalStateException_init_$Create$(toString(message));
  }
}
function checkKind_0(kind) {
  if (kind instanceof ENUM) {
    // Inline function 'kotlin.error' call
    var message = "Enums cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException_init_$Create$(toString(message));
  }
  if (kind instanceof PrimitiveKind) {
    // Inline function 'kotlin.error' call
    var message_0 = "Primitives cannot be serialized polymorphically with 'type' parameter. You can use 'JsonBuilder.useArrayPolymorphism' instead";
    throw IllegalStateException_init_$Create$(toString(message_0));
  }
  if (kind instanceof PolymorphicKind) {
    // Inline function 'kotlin.error' call
    var message_1 = 'Actual serializer for polymorphic cannot be polymorphic itself';
    throw IllegalStateException_init_$Create$(toString(message_1));
  }
}
function access$validateIfSealed$tPolymorphicKt(serializer, actualSerializer, classDiscriminator) {
  return validateIfSealed(serializer, actualSerializer, classDiscriminator);
}
function Key() {
}
function DescriptorSchemaCache() {
  this.v1e_1 = createMapForCache(16);
}
protoOf(DescriptorSchemaCache).i1h = function (descriptor, key, value) {
  // Inline function 'kotlin.collections.getOrPut' call
  var this_0 = this.v1e_1;
  var value_0 = this_0.h2(descriptor);
  var tmp;
  if (value_0 == null) {
    var answer = createMapForCache(2);
    this_0.a2(descriptor, answer);
    tmp = answer;
  } else {
    tmp = value_0;
  }
  var tmp0 = tmp;
  var tmp2 = key instanceof Key ? key : THROW_CCE();
  // Inline function 'kotlin.collections.set' call
  var value_1 = !(value == null) ? value : THROW_CCE();
  tmp0.a2(tmp2, value_1);
};
protoOf(DescriptorSchemaCache).w1e = function (descriptor, key, defaultValue) {
  var tmp0_safe_receiver = this.j1h(descriptor, key);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var value = defaultValue();
  this.i1h(descriptor, key, value);
  return value;
};
protoOf(DescriptorSchemaCache).j1h = function (descriptor, key) {
  var tmp0_safe_receiver = this.v1e_1.h2(descriptor);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    tmp = tmp0_safe_receiver.h2(key instanceof Key ? key : THROW_CCE());
  }
  var tmp_0 = tmp;
  return !(tmp_0 == null) ? tmp_0 : null;
};
function DiscriminatorHolder(discriminatorToSkip) {
  this.k1h_1 = discriminatorToSkip;
}
function trySkip($this, _this__u8e3s4, unknownKey) {
  if (_this__u8e3s4 == null)
    return false;
  if (_this__u8e3s4.k1h_1 === unknownKey) {
    _this__u8e3s4.k1h_1 = null;
    return true;
  }
  return false;
}
function skipLeftoverElements($this, descriptor) {
  while (!($this.jt(descriptor) === -1)) {
  }
}
function checkLeadingComma($this) {
  if ($this.e1a_1.z1f() === 4) {
    $this.e1a_1.u1e('Unexpected leading comma');
  }
}
function decodeMapIndex($this) {
  var hasComma = false;
  var decodingKey = !(($this.g1a_1 % 2 | 0) === 0);
  if (decodingKey) {
    if (!($this.g1a_1 === -1)) {
      hasComma = $this.e1a_1.m1h();
    }
  } else {
    $this.e1a_1.l1h(_Char___init__impl__6a9atx(58));
  }
  var tmp;
  if ($this.e1a_1.a1g()) {
    if (decodingKey) {
      if ($this.g1a_1 === -1) {
        var tmp0 = $this.e1a_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition = !hasComma;
        var position = tmp0.k1a_1;
        if (!condition) {
          var tmp$ret$0 = 'Unexpected leading comma';
          tmp0.u1e(tmp$ret$0, position);
        }
      } else {
        var tmp0_0 = $this.e1a_1;
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.require' call
        var condition_0 = hasComma;
        var position_0 = tmp0_0.k1a_1;
        if (!condition_0) {
          var tmp$ret$2 = 'Expected comma after the key-value pair';
          tmp0_0.u1e(tmp$ret$2, position_0);
        }
      }
    }
    $this.g1a_1 = $this.g1a_1 + 1 | 0;
    tmp = $this.g1a_1;
  } else {
    if (hasComma && !$this.c1a_1.v19_1.w1b_1) {
      invalidTrailingComma($this.e1a_1);
    }
    tmp = -1;
  }
  return tmp;
}
function coerceInputValue($this, descriptor, index) {
  var tmp0 = $this.c1a_1;
  var tmp$ret$1;
  $l$block_2: {
    // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
    var isOptional = descriptor.hr(index);
    var elementDescriptor = descriptor.gr(index);
    var tmp;
    if (isOptional && !elementDescriptor.sq()) {
      tmp = $this.e1a_1.n1h(true);
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$1 = true;
      break $l$block_2;
    }
    if (equals(elementDescriptor.zq(), ENUM_getInstance())) {
      var tmp_0;
      if (elementDescriptor.sq()) {
        tmp_0 = $this.e1a_1.n1h(false);
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$1 = false;
        break $l$block_2;
      }
      var tmp0_elvis_lhs = $this.e1a_1.o1h($this.i1a_1.k1b_1);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$1 = false;
        break $l$block_2;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var enumValue = tmp_1;
      var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
      var coerceToNull = !tmp0.v19_1.n1b_1 && elementDescriptor.sq();
      if (enumIndex === -3 && (isOptional || coerceToNull)) {
        $this.e1a_1.b1g();
        tmp$ret$1 = true;
        break $l$block_2;
      }
    }
    tmp$ret$1 = false;
  }
  return tmp$ret$1;
}
function decodeObjectIndex($this, descriptor) {
  var hasComma = $this.e1a_1.m1h();
  while ($this.e1a_1.a1g()) {
    hasComma = false;
    var key = decodeStringKey($this);
    $this.e1a_1.l1h(_Char___init__impl__6a9atx(58));
    var index = getJsonNameIndex(descriptor, $this.c1a_1, key);
    var tmp;
    if (!(index === -3)) {
      var tmp_0;
      if ($this.i1a_1.p1b_1 && coerceInputValue($this, descriptor, index)) {
        hasComma = $this.e1a_1.m1h();
        tmp_0 = false;
      } else {
        var tmp0_safe_receiver = $this.j1a_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.r1e(index);
        }
        return index;
      }
      tmp = tmp_0;
    } else {
      tmp = true;
    }
    var isUnknown = tmp;
    if (isUnknown) {
      hasComma = handleUnknown($this, descriptor, key);
    }
  }
  if (hasComma && !$this.c1a_1.v19_1.w1b_1) {
    invalidTrailingComma($this.e1a_1);
  }
  var tmp1_safe_receiver = $this.j1a_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.s1e();
  return tmp2_elvis_lhs == null ? -1 : tmp2_elvis_lhs;
}
function handleUnknown($this, descriptor, key) {
  if (ignoreUnknownKeys(descriptor, $this.c1a_1) || trySkip($this, $this.h1a_1, key)) {
    $this.e1a_1.q1h($this.i1a_1.k1b_1);
  } else {
    $this.e1a_1.l1a_1.g1f();
    $this.e1a_1.p1h(key);
  }
  return $this.e1a_1.m1h();
}
function decodeListIndex($this) {
  var hasComma = $this.e1a_1.m1h();
  var tmp;
  if ($this.e1a_1.a1g()) {
    if (!($this.g1a_1 === -1) && !hasComma) {
      $this.e1a_1.u1e('Expected end of the array or comma');
    }
    $this.g1a_1 = $this.g1a_1 + 1 | 0;
    tmp = $this.g1a_1;
  } else {
    if (hasComma && !$this.c1a_1.v19_1.w1b_1) {
      invalidTrailingComma($this.e1a_1, 'array');
    }
    tmp = -1;
  }
  return tmp;
}
function decodeStringKey($this) {
  var tmp;
  if ($this.i1a_1.k1b_1) {
    tmp = $this.e1a_1.s1h();
  } else {
    tmp = $this.e1a_1.r1h();
  }
  return tmp;
}
function StreamingJsonDecoder(json, mode, lexer, descriptor, discriminatorHolder) {
  AbstractDecoder.call(this);
  this.c1a_1 = json;
  this.d1a_1 = mode;
  this.e1a_1 = lexer;
  this.f1a_1 = this.c1a_1.ht();
  this.g1a_1 = -1;
  this.h1a_1 = discriminatorHolder;
  this.i1a_1 = this.c1a_1.v19_1;
  this.j1a_1 = this.i1a_1.n1b_1 ? null : new JsonElementMarker(descriptor);
}
protoOf(StreamingJsonDecoder).d1c = function () {
  return this.c1a_1;
};
protoOf(StreamingJsonDecoder).ht = function () {
  return this.f1a_1;
};
protoOf(StreamingJsonDecoder).b1c = function () {
  return (new JsonTreeReader(this.c1a_1.v19_1, this.e1a_1)).d1g();
};
protoOf(StreamingJsonDecoder).rs = function (deserializer) {
  try {
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = this.c1a_1.v19_1.q1b_1;
    }
    if (tmp) {
      return deserializer.hp(this);
    }
    var discriminator = classDiscriminator(deserializer.fp(), this.c1a_1);
    var tmp0_elvis_lhs = this.e1a_1.t1h(discriminator, this.i1a_1.k1b_1);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      var tmp2 = isInterface(deserializer, DeserializationStrategy) ? deserializer : THROW_CCE();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
        var tmp_1;
        if (!(tmp2 instanceof AbstractPolymorphicSerializer)) {
          tmp_1 = true;
        } else {
          tmp_1 = this.d1c().v19_1.q1b_1;
        }
        if (tmp_1) {
          tmp$ret$0 = tmp2.hp(this);
          break $l$block;
        }
        var discriminator_0 = classDiscriminator(tmp2.fp(), this.d1c());
        var tmp0 = this.b1c();
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName = tmp2.fp().gq();
        if (!(tmp0 instanceof JsonObject)) {
          var tmp_2 = getKClass(JsonObject).ea();
          var tmp_3 = getKClassFromExpression(tmp0).ea();
          var tmp$ret$1 = this.e1a_1.l1a_1.h1f();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(tmp0));
        }
        var jsonTree = tmp0;
        var tmp0_safe_receiver = jsonTree.g1c(discriminator_0);
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
        var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
        var tmp_4;
        try {
          tmp_4 = findPolymorphicSerializer(tmp2, this, type);
        } catch ($p) {
          var tmp_5;
          if ($p instanceof SerializationException) {
            var it = $p;
            throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
          } else {
            throw $p;
          }
        }
        var tmp_6 = tmp_4;
        var actualSerializer = isInterface(tmp_6, DeserializationStrategy) ? tmp_6 : THROW_CCE();
        tmp$ret$0 = readPolymorphicJson(this.d1c(), discriminator_0, jsonTree, actualSerializer);
      }
      return tmp$ret$0;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var type_0 = tmp_0;
    var tmp_7;
    try {
      tmp_7 = findPolymorphicSerializer(deserializer, this, type_0);
    } catch ($p) {
      var tmp_8;
      if ($p instanceof SerializationException) {
        var it_0 = $p;
        var message = removeSuffix(substringBefore(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10)), '.');
        var hint = substringAfter(ensureNotNull(it_0.message), _Char___init__impl__6a9atx(10), '');
        this.e1a_1.u1e(message, VOID, hint);
      } else {
        throw $p;
      }
      tmp_7 = tmp_8;
    }
    var tmp_9 = tmp_7;
    var actualSerializer_0 = isInterface(tmp_9, DeserializationStrategy) ? tmp_9 : THROW_CCE();
    this.h1a_1 = new DiscriminatorHolder(discriminator);
    return actualSerializer_0.hp(this);
  } catch ($p) {
    if ($p instanceof MissingFieldException) {
      var e = $p;
      if (contains_0(ensureNotNull(e.message), 'at path'))
        throw e;
      throw new MissingFieldException(e.mq_1, plus(e.message, ' at path: ') + this.e1a_1.l1a_1.h1f(), e);
    } else {
      throw $p;
    }
  }
};
protoOf(StreamingJsonDecoder).ss = function (descriptor) {
  var newMode = switchMode(this.c1a_1, descriptor);
  this.e1a_1.l1a_1.c1f(descriptor);
  this.e1a_1.l1h(newMode.w1h_1);
  checkLeadingComma(this);
  var tmp;
  switch (newMode.j2_1) {
    case 1:
    case 2:
    case 3:
      tmp = new StreamingJsonDecoder(this.c1a_1, newMode, this.e1a_1, descriptor, this.h1a_1);
      break;
    default:
      var tmp_0;
      if (this.d1a_1.equals(newMode) && this.c1a_1.v19_1.n1b_1) {
        tmp_0 = this;
      } else {
        tmp_0 = new StreamingJsonDecoder(this.c1a_1, newMode, this.e1a_1, descriptor, this.h1a_1);
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).ts = function (descriptor) {
  if (descriptor.br() === 0 && ignoreUnknownKeys(descriptor, this.c1a_1)) {
    skipLeftoverElements(this, descriptor);
  }
  if (this.e1a_1.m1h() && !this.c1a_1.v19_1.w1b_1) {
    invalidTrailingComma(this.e1a_1, '');
  }
  this.e1a_1.l1h(this.d1a_1.x1h_1);
  this.e1a_1.l1a_1.g1f();
};
protoOf(StreamingJsonDecoder).ds = function () {
  var tmp;
  var tmp0_safe_receiver = this.j1a_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q1e_1;
  if (!(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs)) {
    tmp = !this.e1a_1.y1h();
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).es = function () {
  return null;
};
protoOf(StreamingJsonDecoder).et = function (descriptor, index, deserializer, previousValue) {
  var isMapKey = this.d1a_1.equals(WriteMode_MAP_getInstance()) && (index & 1) === 0;
  if (isMapKey) {
    this.e1a_1.l1a_1.f1f();
  }
  var value = protoOf(AbstractDecoder).et.call(this, descriptor, index, deserializer, previousValue);
  if (isMapKey) {
    this.e1a_1.l1a_1.e1f(value);
  }
  return value;
};
protoOf(StreamingJsonDecoder).jt = function (descriptor) {
  var index;
  switch (this.d1a_1.j2_1) {
    case 0:
      index = decodeObjectIndex(this, descriptor);
      break;
    case 2:
      index = decodeMapIndex(this);
      break;
    default:
      index = decodeListIndex(this);
      break;
  }
  if (!this.d1a_1.equals(WriteMode_MAP_getInstance())) {
    this.e1a_1.l1a_1.d1f(index);
  }
  return index;
};
protoOf(StreamingJsonDecoder).fs = function () {
  return this.e1a_1.z1h();
};
protoOf(StreamingJsonDecoder).gs = function () {
  var value = this.e1a_1.a1i();
  if (!(value === fromInt(convertToByte(value)))) {
    this.e1a_1.u1e("Failed to parse byte for input '" + value.toString() + "'");
  }
  return convertToByte(value);
};
protoOf(StreamingJsonDecoder).hs = function () {
  var value = this.e1a_1.a1i();
  if (!(value === fromInt(convertToShort(value)))) {
    this.e1a_1.u1e("Failed to parse short for input '" + value.toString() + "'");
  }
  return convertToShort(value);
};
protoOf(StreamingJsonDecoder).is = function () {
  var value = this.e1a_1.a1i();
  if (!(value === fromInt(convertToInt(value)))) {
    this.e1a_1.u1e("Failed to parse int for input '" + value.toString() + "'");
  }
  return convertToInt(value);
};
protoOf(StreamingJsonDecoder).js = function () {
  return this.e1a_1.a1i();
};
protoOf(StreamingJsonDecoder).ks = function () {
  var tmp0 = this.e1a_1;
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c1g();
    try {
      // Inline function 'kotlin.text.toFloat' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp$ret$4 = toDouble(input);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.u1e("Failed to parse type '" + 'float' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.c1a_1.v19_1.s1b_1;
  if (specialFp || isFinite(result))
    return result;
  throwInvalidFloatingPointDecoded(this.e1a_1, result);
};
protoOf(StreamingJsonDecoder).ls = function () {
  var tmp0 = this.e1a_1;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c1g();
    try {
      tmp$ret$1 = toDouble(input);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.u1e("Failed to parse type '" + 'double' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$1;
  var specialFp = this.c1a_1.v19_1.s1b_1;
  if (specialFp || isFinite_0(result))
    return result;
  throwInvalidFloatingPointDecoded(this.e1a_1, result);
};
protoOf(StreamingJsonDecoder).ms = function () {
  var string = this.e1a_1.c1g();
  if (!(string.length === 1)) {
    this.e1a_1.u1e("Expected single char, but got '" + string + "'");
  }
  return charCodeAt(string, 0);
};
protoOf(StreamingJsonDecoder).ns = function () {
  var tmp;
  if (this.i1a_1.k1b_1) {
    tmp = this.e1a_1.s1h();
  } else {
    tmp = this.e1a_1.b1g();
  }
  return tmp;
};
protoOf(StreamingJsonDecoder).ps = function (descriptor) {
  return get_isUnsignedNumber(descriptor) ? new JsonDecoderForUnsignedTypes(this.e1a_1, this.c1a_1) : protoOf(AbstractDecoder).ps.call(this, descriptor);
};
protoOf(StreamingJsonDecoder).os = function (enumDescriptor) {
  return getJsonNameIndexOrThrow(enumDescriptor, this.c1a_1, this.ns(), ' at path ' + this.e1a_1.l1a_1.h1f());
};
function JsonDecoderForUnsignedTypes(lexer, json) {
  AbstractDecoder.call(this);
  this.b1i_1 = lexer;
  this.c1i_1 = json.ht();
}
protoOf(JsonDecoderForUnsignedTypes).ht = function () {
  return this.c1i_1;
};
protoOf(JsonDecoderForUnsignedTypes).jt = function (descriptor) {
  var message = 'unsupported';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(JsonDecoderForUnsignedTypes).is = function () {
  var tmp0 = this.b1i_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c1g();
    try {
      // Inline function 'kotlin.UInt.toInt' call
      var this_0 = toUInt(input);
      tmp$ret$2 = _UInt___get_data__impl__f0vqqw(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.u1e("Failed to parse type '" + 'UInt' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).js = function () {
  var tmp0 = this.b1i_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c1g();
    try {
      // Inline function 'kotlin.ULong.toLong' call
      var this_0 = toULong(input);
      tmp$ret$2 = _ULong___get_data__impl__fggpzb(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.u1e("Failed to parse type '" + 'ULong' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).gs = function () {
  var tmp0 = this.b1i_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c1g();
    try {
      // Inline function 'kotlin.UByte.toByte' call
      var this_0 = toUByte(input);
      tmp$ret$2 = _UByte___get_data__impl__jof9qr(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.u1e("Failed to parse type '" + 'UByte' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
protoOf(JsonDecoderForUnsignedTypes).hs = function () {
  var tmp0 = this.b1i_1;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.parseString' call
    var input = tmp0.c1g();
    try {
      // Inline function 'kotlin.UShort.toShort' call
      var this_0 = toUShort(input);
      tmp$ret$2 = _UShort___get_data__impl__g0245(this_0);
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        tmp0.u1e("Failed to parse type '" + 'UShort' + "' for input '" + input + "'");
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$2;
};
function get_unsignedNumberDescriptors() {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return unsignedNumberDescriptors;
}
var unsignedNumberDescriptors;
function StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, $this) {
  StreamingJsonEncoder.call($this, Composer_0(output, json), json, mode, modeReuseCache);
  return $this;
}
function StreamingJsonEncoder_init_$Create$(output, json, mode, modeReuseCache) {
  return StreamingJsonEncoder_init_$Init$(output, json, mode, modeReuseCache, objectCreate(protoOf(StreamingJsonEncoder)));
}
function encodeTypeInfo($this, discriminator, serialName) {
  $this.l1f_1.o1d();
  $this.wt(discriminator);
  $this.l1f_1.r1d(_Char___init__impl__6a9atx(58));
  $this.l1f_1.q1d();
  $this.wt(serialName);
}
function StreamingJsonEncoder(composer, json, mode, modeReuseCache) {
  AbstractEncoder.call(this);
  this.l1f_1 = composer;
  this.m1f_1 = json;
  this.n1f_1 = mode;
  this.o1f_1 = modeReuseCache;
  this.p1f_1 = this.m1f_1.ht();
  this.q1f_1 = this.m1f_1.v19_1;
  this.r1f_1 = false;
  this.s1f_1 = null;
  this.t1f_1 = null;
  var i = this.n1f_1.j2_1;
  if (!(this.o1f_1 == null)) {
    if (!(this.o1f_1[i] === null) || !(this.o1f_1[i] === this)) {
      this.o1f_1[i] = this;
    }
  }
}
protoOf(StreamingJsonEncoder).d1c = function () {
  return this.m1f_1;
};
protoOf(StreamingJsonEncoder).ht = function () {
  return this.p1f_1;
};
protoOf(StreamingJsonEncoder).pu = function (descriptor, index) {
  return this.q1f_1.i1b_1;
};
protoOf(StreamingJsonEncoder).ku = function (serializer, value) {
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.encodePolymorphically' call
    if (this.d1c().v19_1.q1b_1) {
      serializer.gp(this, value);
      break $l$block;
    }
    var isPolymorphicSerializer = serializer instanceof AbstractPolymorphicSerializer;
    var tmp;
    if (isPolymorphicSerializer) {
      tmp = !this.d1c().v19_1.y1b_1.equals(ClassDiscriminatorMode_NONE_getInstance());
    } else {
      var tmp_0;
      switch (this.d1c().v19_1.y1b_1.j2_1) {
        case 0:
        case 2:
          tmp_0 = false;
          break;
        case 1:
          // Inline function 'kotlin.let' call

          var it = serializer.fp().zq();
          tmp_0 = equals(it, CLASS_getInstance()) || equals(it, OBJECT_getInstance());
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    }
    var needDiscriminator = tmp;
    var baseClassDiscriminator = needDiscriminator ? classDiscriminator(serializer.fp(), this.d1c()) : null;
    var tmp_1;
    if (isPolymorphicSerializer) {
      var casted = serializer instanceof AbstractPolymorphicSerializer ? serializer : THROW_CCE();
      $l$block_0: {
        // Inline function 'kotlin.requireNotNull' call
        if (value == null) {
          var message = 'Value for serializer ' + toString(serializer.fp()) + ' should always be non-null. Please report issue to the kotlinx.serialization tracker.';
          throw IllegalArgumentException_init_$Create$(toString(message));
        } else {
          break $l$block_0;
        }
      }
      var actual = findPolymorphicSerializer_0(casted, this, value);
      if (!(baseClassDiscriminator == null)) {
        access$validateIfSealed$tPolymorphicKt(serializer, actual, baseClassDiscriminator);
        checkKind_0(actual.fp().zq());
      }
      tmp_1 = isInterface(actual, SerializationStrategy) ? actual : THROW_CCE();
    } else {
      tmp_1 = serializer;
    }
    var actualSerializer = tmp_1;
    if (!(baseClassDiscriminator == null)) {
      var serialName = actualSerializer.fp().gq();
      this.s1f_1 = baseClassDiscriminator;
      this.t1f_1 = serialName;
    }
    actualSerializer.gp(this, value);
  }
};
protoOf(StreamingJsonEncoder).ss = function (descriptor) {
  var newMode = switchMode(this.m1f_1, descriptor);
  if (!(newMode.w1h_1 === _Char___init__impl__6a9atx(0))) {
    this.l1f_1.r1d(newMode.w1h_1);
    this.l1f_1.m1d();
  }
  var discriminator = this.s1f_1;
  if (!(discriminator == null)) {
    var tmp0_elvis_lhs = this.t1f_1;
    encodeTypeInfo(this, discriminator, tmp0_elvis_lhs == null ? descriptor.gq() : tmp0_elvis_lhs);
    this.s1f_1 = null;
    this.t1f_1 = null;
  }
  if (this.n1f_1.equals(newMode)) {
    return this;
  }
  var tmp1_safe_receiver = this.o1f_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver[newMode.j2_1];
  return tmp2_elvis_lhs == null ? new StreamingJsonEncoder(this.l1f_1, this.m1f_1, newMode, this.o1f_1) : tmp2_elvis_lhs;
};
protoOf(StreamingJsonEncoder).ts = function (descriptor) {
  if (!(this.n1f_1.x1h_1 === _Char___init__impl__6a9atx(0))) {
    this.l1f_1.n1d();
    this.l1f_1.p1d();
    this.l1f_1.r1d(this.n1f_1.x1h_1);
  }
};
protoOf(StreamingJsonEncoder).lt = function (descriptor, index) {
  switch (this.n1f_1.j2_1) {
    case 1:
      if (!this.l1f_1.l1d_1) {
        this.l1f_1.r1d(_Char___init__impl__6a9atx(44));
      }

      this.l1f_1.o1d();
      break;
    case 2:
      if (!this.l1f_1.l1d_1) {
        var tmp = this;
        var tmp_0;
        if ((index % 2 | 0) === 0) {
          this.l1f_1.r1d(_Char___init__impl__6a9atx(44));
          this.l1f_1.o1d();
          tmp_0 = true;
        } else {
          this.l1f_1.r1d(_Char___init__impl__6a9atx(58));
          this.l1f_1.q1d();
          tmp_0 = false;
        }
        tmp.r1f_1 = tmp_0;
      } else {
        this.r1f_1 = true;
        this.l1f_1.o1d();
      }

      break;
    case 3:
      if (index === 0)
        this.r1f_1 = true;
      if (index === 1) {
        this.l1f_1.r1d(_Char___init__impl__6a9atx(44));
        this.l1f_1.q1d();
        this.r1f_1 = false;
      }

      break;
    default:
      if (!this.l1f_1.l1d_1) {
        this.l1f_1.r1d(_Char___init__impl__6a9atx(44));
      }

      this.l1f_1.o1d();
      this.wt(getJsonElementName(descriptor, this.m1f_1, index));
      this.l1f_1.r1d(_Char___init__impl__6a9atx(58));
      this.l1f_1.q1d();
      break;
  }
  return true;
};
protoOf(StreamingJsonEncoder).lu = function (descriptor, index, serializer, value) {
  if (!(value == null) || this.q1f_1.n1b_1) {
    protoOf(AbstractEncoder).lu.call(this, descriptor, index, serializer, value);
  }
};
protoOf(StreamingJsonEncoder).yt = function (descriptor) {
  var tmp;
  if (get_isUnsignedNumber(descriptor)) {
    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
    var tmp_0;
    var tmp_1 = this.l1f_1;
    if (tmp_1 instanceof ComposerForUnsignedNumbers) {
      tmp_0 = this.l1f_1;
    } else {
      var tmp0 = this.l1f_1.k1d_1;
      var p1 = this.r1f_1;
      tmp_0 = new ComposerForUnsignedNumbers(tmp0, p1);
    }
    var tmp$ret$1 = tmp_0;
    tmp = new StreamingJsonEncoder(tmp$ret$1, this.m1f_1, this.n1f_1, null);
  } else if (get_isUnquotedLiteral(descriptor)) {
    // Inline function 'kotlinx.serialization.json.internal.StreamingJsonEncoder.composerAs' call
    var tmp_2;
    var tmp_3 = this.l1f_1;
    if (tmp_3 instanceof ComposerForUnquotedLiterals) {
      tmp_2 = this.l1f_1;
    } else {
      var tmp0_0 = this.l1f_1.k1d_1;
      var p1_0 = this.r1f_1;
      tmp_2 = new ComposerForUnquotedLiterals(tmp0_0, p1_0);
    }
    var tmp$ret$3 = tmp_2;
    tmp = new StreamingJsonEncoder(tmp$ret$3, this.m1f_1, this.n1f_1, null);
  } else if (!(this.s1f_1 == null)) {
    // Inline function 'kotlin.apply' call
    this.t1f_1 = descriptor.gq();
    tmp = this;
  } else {
    tmp = protoOf(AbstractEncoder).yt.call(this, descriptor);
  }
  return tmp;
};
protoOf(StreamingJsonEncoder).nt = function () {
  this.l1f_1.t1d('null');
};
protoOf(StreamingJsonEncoder).ot = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.c1e(value);
  }
};
protoOf(StreamingJsonEncoder).pt = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.x1d(value);
  }
};
protoOf(StreamingJsonEncoder).qt = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.z1d(value);
  }
};
protoOf(StreamingJsonEncoder).rt = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.a1e(value);
  }
};
protoOf(StreamingJsonEncoder).st = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.b1e(value);
  }
};
protoOf(StreamingJsonEncoder).tt = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.v1d(value);
  }
  if (!this.q1f_1.s1b_1 && !isFinite(value)) {
    throw InvalidFloatingPointEncoded(value, toString(this.l1f_1.k1d_1));
  }
};
protoOf(StreamingJsonEncoder).ut = function (value) {
  if (this.r1f_1) {
    this.wt(value.toString());
  } else {
    this.l1f_1.w1d(value);
  }
  if (!this.q1f_1.s1b_1 && !isFinite_0(value)) {
    throw InvalidFloatingPointEncoded(value, toString(this.l1f_1.k1d_1));
  }
};
protoOf(StreamingJsonEncoder).vt = function (value) {
  this.wt(toString_1(value));
};
protoOf(StreamingJsonEncoder).wt = function (value) {
  return this.l1f_1.d1e(value);
};
protoOf(StreamingJsonEncoder).xt = function (enumDescriptor, index) {
  this.wt(enumDescriptor.dr(index));
};
function get_isUnsignedNumber(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.ar() && get_unsignedNumberDescriptors().q1(_this__u8e3s4);
}
function get_isUnquotedLiteral(_this__u8e3s4) {
  _init_properties_StreamingJsonEncoder_kt__pn1bsi();
  return _this__u8e3s4.ar() && equals(_this__u8e3s4, get_jsonUnquotedLiteralDescriptor());
}
var properties_initialized_StreamingJsonEncoder_kt_6ifwwk;
function _init_properties_StreamingJsonEncoder_kt__pn1bsi() {
  if (!properties_initialized_StreamingJsonEncoder_kt_6ifwwk) {
    properties_initialized_StreamingJsonEncoder_kt_6ifwwk = true;
    unsignedNumberDescriptors = setOf([serializer_1(Companion_getInstance_0()).fp(), serializer_0(Companion_getInstance()).fp(), serializer_2(Companion_getInstance_1()).fp(), serializer_3(Companion_getInstance_2()).fp()]);
  }
}
function get_ESCAPE_STRINGS() {
  _init_properties_StringOps_kt__fcy1db();
  return ESCAPE_STRINGS;
}
var ESCAPE_STRINGS;
var ESCAPE_MARKERS;
function printQuoted(_this__u8e3s4, value) {
  _init_properties_StringOps_kt__fcy1db();
  _this__u8e3s4.l7(_Char___init__impl__6a9atx(34));
  var lastPos = 0;
  var inductionVariable = 0;
  var last = charSequenceLength(value) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.code' call
      var this_0 = charCodeAt(value, i);
      var c = Char__toInt_impl_vasixd(this_0);
      if (c < get_ESCAPE_STRINGS().length && !(get_ESCAPE_STRINGS()[c] == null)) {
        _this__u8e3s4.vb(value, lastPos, i);
        _this__u8e3s4.k7(get_ESCAPE_STRINGS()[c]);
        lastPos = i + 1 | 0;
      }
    }
     while (inductionVariable <= last);
  if (!(lastPos === 0))
    _this__u8e3s4.vb(value, lastPos, value.length);
  else
    _this__u8e3s4.k7(value);
  _this__u8e3s4.l7(_Char___init__impl__6a9atx(34));
}
function toHexChar(i) {
  _init_properties_StringOps_kt__fcy1db();
  var d = i & 15;
  var tmp;
  if (d < 10) {
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp = numberToChar(d + tmp$ret$0 | 0);
  } else {
    var tmp_0 = d - 10 | 0;
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
    tmp = numberToChar(tmp_0 + tmp$ret$1 | 0);
  }
  return tmp;
}
function toBooleanStrictOrNull_0(_this__u8e3s4) {
  _init_properties_StringOps_kt__fcy1db();
  return equals_0(_this__u8e3s4, 'true', true) ? true : equals_0(_this__u8e3s4, 'false', true) ? false : null;
}
var properties_initialized_StringOps_kt_wzaea7;
function _init_properties_StringOps_kt__fcy1db() {
  if (!properties_initialized_StringOps_kt_wzaea7) {
    properties_initialized_StringOps_kt_wzaea7 = true;
    // Inline function 'kotlin.arrayOfNulls' call
    // Inline function 'kotlin.apply' call
    var this_0 = Array(93);
    var inductionVariable = 0;
    if (inductionVariable <= 31)
      do {
        var c = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c1 = toHexChar(c >> 12);
        var c2 = toHexChar(c >> 8);
        var c3 = toHexChar(c >> 4);
        var c4 = toHexChar(c);
        this_0[c] = '\\u' + toString_1(c1) + toString_1(c2) + toString_1(c3) + toString_1(c4);
      }
       while (inductionVariable <= 31);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(34);
    this_0[Char__toInt_impl_vasixd(this_1)] = '\\"';
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(92);
    this_0[Char__toInt_impl_vasixd(this_2)] = '\\\\';
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(9);
    this_0[Char__toInt_impl_vasixd(this_3)] = '\\t';
    // Inline function 'kotlin.code' call
    var this_4 = _Char___init__impl__6a9atx(8);
    this_0[Char__toInt_impl_vasixd(this_4)] = '\\b';
    // Inline function 'kotlin.code' call
    var this_5 = _Char___init__impl__6a9atx(10);
    this_0[Char__toInt_impl_vasixd(this_5)] = '\\n';
    // Inline function 'kotlin.code' call
    var this_6 = _Char___init__impl__6a9atx(13);
    this_0[Char__toInt_impl_vasixd(this_6)] = '\\r';
    this_0[12] = '\\f';
    ESCAPE_STRINGS = this_0;
    // Inline function 'kotlin.apply' call
    var this_7 = new Int8Array(93);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 <= 31)
      do {
        var c_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this_7[c_0] = 1;
      }
       while (inductionVariable_0 <= 31);
    // Inline function 'kotlin.code' call
    var this_8 = _Char___init__impl__6a9atx(34);
    var tmp = Char__toInt_impl_vasixd(this_8);
    // Inline function 'kotlin.code' call
    var this_9 = _Char___init__impl__6a9atx(34);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_9);
    this_7[tmp] = toByte(tmp$ret$1);
    // Inline function 'kotlin.code' call
    var this_10 = _Char___init__impl__6a9atx(92);
    var tmp_0 = Char__toInt_impl_vasixd(this_10);
    // Inline function 'kotlin.code' call
    var this_11 = _Char___init__impl__6a9atx(92);
    var tmp$ret$3 = Char__toInt_impl_vasixd(this_11);
    this_7[tmp_0] = toByte(tmp$ret$3);
    // Inline function 'kotlin.code' call
    var this_12 = _Char___init__impl__6a9atx(9);
    var tmp_1 = Char__toInt_impl_vasixd(this_12);
    // Inline function 'kotlin.code' call
    var this_13 = _Char___init__impl__6a9atx(116);
    var tmp$ret$5 = Char__toInt_impl_vasixd(this_13);
    this_7[tmp_1] = toByte(tmp$ret$5);
    // Inline function 'kotlin.code' call
    var this_14 = _Char___init__impl__6a9atx(8);
    var tmp_2 = Char__toInt_impl_vasixd(this_14);
    // Inline function 'kotlin.code' call
    var this_15 = _Char___init__impl__6a9atx(98);
    var tmp$ret$7 = Char__toInt_impl_vasixd(this_15);
    this_7[tmp_2] = toByte(tmp$ret$7);
    // Inline function 'kotlin.code' call
    var this_16 = _Char___init__impl__6a9atx(10);
    var tmp_3 = Char__toInt_impl_vasixd(this_16);
    // Inline function 'kotlin.code' call
    var this_17 = _Char___init__impl__6a9atx(110);
    var tmp$ret$9 = Char__toInt_impl_vasixd(this_17);
    this_7[tmp_3] = toByte(tmp$ret$9);
    // Inline function 'kotlin.code' call
    var this_18 = _Char___init__impl__6a9atx(13);
    var tmp_4 = Char__toInt_impl_vasixd(this_18);
    // Inline function 'kotlin.code' call
    var this_19 = _Char___init__impl__6a9atx(114);
    var tmp$ret$11 = Char__toInt_impl_vasixd(this_19);
    this_7[tmp_4] = toByte(tmp$ret$11);
    // Inline function 'kotlin.code' call
    var this_20 = _Char___init__impl__6a9atx(102);
    var tmp$ret$12 = Char__toInt_impl_vasixd(this_20);
    this_7[12] = toByte(tmp$ret$12);
    ESCAPE_MARKERS = this_7;
  }
}
function readJson(json, element, deserializer) {
  var tmp;
  if (element instanceof JsonObject) {
    tmp = new JsonTreeDecoder(json, element);
  } else {
    if (element instanceof JsonArray) {
      tmp = new JsonTreeListDecoder(json, element);
    } else {
      var tmp_0;
      if (element instanceof JsonLiteral) {
        tmp_0 = true;
      } else {
        tmp_0 = equals(element, JsonNull_getInstance());
      }
      if (tmp_0) {
        tmp = new JsonPrimitiveDecoder(json, element instanceof JsonPrimitive ? element : THROW_CCE());
      } else {
        noWhenBranchMatchedException();
      }
    }
  }
  var input = tmp;
  return input.rs(deserializer);
}
function unparsedPrimitive($this, literal, primitive, tag) {
  var type = startsWith(primitive, 'i') ? 'an ' + primitive : 'a ' + primitive;
  throw JsonDecodingException_0(-1, "Failed to parse literal '" + literal.toString() + "' as " + type + ' value at element: ' + $this.j1i(tag), toString($this.k1i()));
}
function AbstractJsonTreeDecoder(json, value, polymorphicDiscriminator) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  NamedValueDecoder.call(this);
  this.f1i_1 = json;
  this.g1i_1 = value;
  this.h1i_1 = polymorphicDiscriminator;
  this.i1i_1 = this.d1c().v19_1;
}
protoOf(AbstractJsonTreeDecoder).d1c = function () {
  return this.f1i_1;
};
protoOf(AbstractJsonTreeDecoder).w = function () {
  return this.g1i_1;
};
protoOf(AbstractJsonTreeDecoder).ht = function () {
  return this.d1c().ht();
};
protoOf(AbstractJsonTreeDecoder).k1i = function () {
  var tmp0_safe_receiver = this.c17();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = this.l1i(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? this.w() : tmp1_elvis_lhs;
};
protoOf(AbstractJsonTreeDecoder).j1i = function (currentTag) {
  return this.e17() + ('.' + currentTag);
};
protoOf(AbstractJsonTreeDecoder).b1c = function () {
  return this.k1i();
};
protoOf(AbstractJsonTreeDecoder).rs = function (deserializer) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.decodeSerializableValuePolymorphic' call
    var tmp;
    if (!(deserializer instanceof AbstractPolymorphicSerializer)) {
      tmp = true;
    } else {
      tmp = this.d1c().v19_1.q1b_1;
    }
    if (tmp) {
      tmp$ret$0 = deserializer.hp(this);
      break $l$block;
    }
    var discriminator = classDiscriminator(deserializer.fp(), this.d1c());
    var tmp0 = this.b1c();
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = deserializer.fp().gq();
    if (!(tmp0 instanceof JsonObject)) {
      var tmp_0 = getKClass(JsonObject).ea();
      var tmp_1 = getKClassFromExpression(tmp0).ea();
      var tmp$ret$1 = this.e17();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$1, toString(tmp0));
    }
    var jsonTree = tmp0;
    var tmp0_safe_receiver = jsonTree.g1c(discriminator);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_jsonPrimitive(tmp0_safe_receiver);
    var type = tmp1_safe_receiver == null ? null : get_contentOrNull(tmp1_safe_receiver);
    var tmp_2;
    try {
      tmp_2 = findPolymorphicSerializer(deserializer, this, type);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof SerializationException) {
        var it = $p;
        throw JsonDecodingException_0(-1, ensureNotNull(it.message), jsonTree.toString());
      } else {
        throw $p;
      }
    }
    var tmp_4 = tmp_2;
    var actualSerializer = isInterface(tmp_4, DeserializationStrategy) ? tmp_4 : THROW_CCE();
    tmp$ret$0 = readPolymorphicJson(this.d1c(), discriminator, jsonTree, actualSerializer);
  }
  return tmp$ret$0;
};
protoOf(AbstractJsonTreeDecoder).d17 = function (parentName, childName) {
  return childName;
};
protoOf(AbstractJsonTreeDecoder).ss = function (descriptor) {
  var currentObject = this.k1i();
  var tmp0_subject = descriptor.zq();
  var tmp;
  var tmp_0;
  if (equals(tmp0_subject, LIST_getInstance())) {
    tmp_0 = true;
  } else {
    tmp_0 = tmp0_subject instanceof PolymorphicKind;
  }
  if (tmp_0) {
    var tmp_1 = this.d1c();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = descriptor.gq();
    if (!(currentObject instanceof JsonArray)) {
      var tmp_2 = getKClass(JsonArray).ea();
      var tmp_3 = getKClassFromExpression(currentObject).ea();
      var tmp$ret$0 = this.e17();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_2 + ', but had ' + tmp_3 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(currentObject));
    }
    tmp = new JsonTreeListDecoder(tmp_1, currentObject);
  } else {
    if (equals(tmp0_subject, MAP_getInstance())) {
      // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
      var this_0 = this.d1c();
      var keyDescriptor = carrierDescriptor(descriptor.gr(0), this_0.ht());
      var keyKind = keyDescriptor.zq();
      var tmp_4;
      var tmp_5;
      if (keyKind instanceof PrimitiveKind) {
        tmp_5 = true;
      } else {
        tmp_5 = equals(keyKind, ENUM_getInstance());
      }
      if (tmp_5) {
        var tmp_6 = this.d1c();
        // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
        // Inline function 'kotlinx.serialization.json.internal.cast' call
        var serialName_0 = descriptor.gq();
        if (!(currentObject instanceof JsonObject)) {
          var tmp_7 = getKClass(JsonObject).ea();
          var tmp_8 = getKClassFromExpression(currentObject).ea();
          var tmp$ret$3 = this.e17();
          throw JsonDecodingException_0(-1, 'Expected ' + tmp_7 + ', but had ' + tmp_8 + ' as the serialized body of ' + serialName_0 + ' at element: ' + tmp$ret$3, toString(currentObject));
        }
        tmp_4 = new JsonTreeMapDecoder(tmp_6, currentObject);
      } else {
        if (this_0.v19_1.l1b_1) {
          var tmp_9 = this.d1c();
          // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
          // Inline function 'kotlinx.serialization.json.internal.cast' call
          var serialName_1 = descriptor.gq();
          if (!(currentObject instanceof JsonArray)) {
            var tmp_10 = getKClass(JsonArray).ea();
            var tmp_11 = getKClassFromExpression(currentObject).ea();
            var tmp$ret$7 = this.e17();
            throw JsonDecodingException_0(-1, 'Expected ' + tmp_10 + ', but had ' + tmp_11 + ' as the serialized body of ' + serialName_1 + ' at element: ' + tmp$ret$7, toString(currentObject));
          }
          tmp_4 = new JsonTreeListDecoder(tmp_9, currentObject);
        } else {
          throw InvalidKeyKindException(keyDescriptor);
        }
      }
      tmp = tmp_4;
    } else {
      var tmp_12 = this.d1c();
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
      // Inline function 'kotlinx.serialization.json.internal.cast' call
      var serialName_2 = descriptor.gq();
      if (!(currentObject instanceof JsonObject)) {
        var tmp_13 = getKClass(JsonObject).ea();
        var tmp_14 = getKClassFromExpression(currentObject).ea();
        var tmp$ret$12 = this.e17();
        throw JsonDecodingException_0(-1, 'Expected ' + tmp_13 + ', but had ' + tmp_14 + ' as the serialized body of ' + serialName_2 + ' at element: ' + tmp$ret$12, toString(currentObject));
      }
      tmp = new JsonTreeDecoder(tmp_12, currentObject, this.h1i_1);
    }
  }
  return tmp;
};
protoOf(AbstractJsonTreeDecoder).ts = function (descriptor) {
};
protoOf(AbstractJsonTreeDecoder).ds = function () {
  var tmp = this.k1i();
  return !(tmp instanceof JsonNull);
};
protoOf(AbstractJsonTreeDecoder).m1i = function (tag, enumDescriptor) {
  var tmp = this.d1c();
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
  var tmp2 = this.l1i(tag);
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
  // Inline function 'kotlinx.serialization.json.internal.cast' call
  var serialName = enumDescriptor.gq();
  if (!(tmp2 instanceof JsonPrimitive)) {
    var tmp_0 = getKClass(JsonPrimitive).ea();
    var tmp_1 = getKClassFromExpression(tmp2).ea();
    var tmp$ret$0 = this.j1i(tag);
    throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp2));
  }
  return getJsonNameIndexOrThrow(enumDescriptor, tmp, tmp2.h1c());
};
protoOf(AbstractJsonTreeDecoder).q17 = function (tag, enumDescriptor) {
  return this.m1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), enumDescriptor);
};
protoOf(AbstractJsonTreeDecoder).n1i = function (tag) {
  return !(this.l1i(tag) === JsonNull_getInstance());
};
protoOf(AbstractJsonTreeDecoder).g17 = function (tag) {
  return this.n1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).o1i = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'boolean' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_booleanOrNull(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'boolean', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'boolean', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).h17 = function (tag) {
  return this.o1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).p1i = function (tag) {
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'byte' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var result = parseLongImpl(literal);
      var tmp_1;
      // Inline function 'kotlin.ranges.contains' call
      var this_0 = numberRangeToNumber(-128, 127);
      if (contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
        tmp_1 = convertToByte(result);
      } else {
        tmp_1 = null;
      }
      var tmp0_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'byte', tag);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      tmp$ret$5 = tmp_2;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'byte', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$5;
};
protoOf(AbstractJsonTreeDecoder).i17 = function (tag) {
  return this.p1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).q1i = function (tag) {
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'short' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var result = parseLongImpl(literal);
      var tmp_1;
      // Inline function 'kotlin.ranges.contains' call
      var this_0 = numberRangeToNumber(-32768, 32767);
      if (contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
        tmp_1 = convertToShort(result);
      } else {
        tmp_1 = null;
      }
      var tmp0_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'short', tag);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      tmp$ret$5 = tmp_2;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'short', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$5;
};
protoOf(AbstractJsonTreeDecoder).j17 = function (tag) {
  return this.q1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).r1i = function (tag) {
  var tmp$ret$5;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'int' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var result = parseLongImpl(literal);
      var tmp_1;
      // Inline function 'kotlin.ranges.contains' call
      var this_0 = numberRangeToNumber(-2147483648, 2147483647);
      if (contains(isInterface(this_0, ClosedRange) ? this_0 : THROW_CCE(), result)) {
        tmp_1 = convertToInt(result);
      } else {
        tmp_1 = null;
      }
      var tmp0_elvis_lhs = tmp_1;
      var tmp_2;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'int', tag);
      } else {
        tmp_2 = tmp0_elvis_lhs;
      }
      tmp$ret$5 = tmp_2;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'int', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$5;
};
protoOf(AbstractJsonTreeDecoder).k17 = function (tag) {
  return this.r1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).s1i = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'long' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = parseLongImpl(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'long', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'long', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).l17 = function (tag) {
  return this.s1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).t1i = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'float' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_float(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'float', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'float', tag);
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.d1c().v19_1.s1b_1;
  if (specialFp || isFinite(result))
    return result;
  throw InvalidFloatingPointDecoded(result, tag, toString(this.k1i()));
};
protoOf(AbstractJsonTreeDecoder).m17 = function (tag) {
  return this.t1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).u1i = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'double' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = get_double(literal);
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'double', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'double', tag);
      } else {
        throw $p;
      }
    }
  }
  var result = tmp$ret$4;
  var specialFp = this.d1c().v19_1.s1b_1;
  if (specialFp || isFinite_0(result))
    return result;
  throw InvalidFloatingPointDecoded(result, tag, toString(this.k1i()));
};
protoOf(AbstractJsonTreeDecoder).n17 = function (tag) {
  return this.u1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).v1i = function (tag) {
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var value = this.l1i(tag);
    if (!(value instanceof JsonPrimitive)) {
      var tmp = getKClass(JsonPrimitive).ea();
      var tmp_0 = getKClassFromExpression(value).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'char' + ' at element: ' + tmp$ret$0, toString(value));
    }
    var literal = value;
    try {
      var tmp0_elvis_lhs = new Char(single(literal.h1c()));
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        unparsedPrimitive(this, literal, 'char', tag);
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      tmp$ret$4 = tmp_1.e1_1;
      break $l$block;
    } catch ($p) {
      if ($p instanceof IllegalArgumentException) {
        var e = $p;
        unparsedPrimitive(this, literal, 'char', tag);
      } else {
        throw $p;
      }
    }
  }
  return tmp$ret$4;
};
protoOf(AbstractJsonTreeDecoder).o17 = function (tag) {
  return this.v1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).w1i = function (tag) {
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
  // Inline function 'kotlinx.serialization.json.internal.cast' call
  var value = this.l1i(tag);
  if (!(value instanceof JsonPrimitive)) {
    var tmp = getKClass(JsonPrimitive).ea();
    var tmp_0 = getKClassFromExpression(value).ea();
    var tmp$ret$0 = this.j1i(tag);
    throw JsonDecodingException_0(-1, 'Expected ' + tmp + ', but had ' + tmp_0 + ' as the serialized body of ' + 'string' + ' at element: ' + tmp$ret$0, toString(value));
  }
  var value_0 = value;
  if (!(value_0 instanceof JsonLiteral))
    throw JsonDecodingException_0(-1, "Expected string value for a non-null key '" + tag + "', got null literal instead at element: " + this.j1i(tag), toString(this.k1i()));
  if (!value_0.p1c_1 && !this.d1c().v19_1.k1b_1) {
    throw JsonDecodingException_0(-1, "String literal for key '" + tag + "' should be quoted at element: " + this.j1i(tag) + ".\nUse 'isLenient = true' in 'Json {}' builder to accept non-compliant JSON.", toString(this.k1i()));
  }
  return value_0.r1c_1;
};
protoOf(AbstractJsonTreeDecoder).p17 = function (tag) {
  return this.w1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE());
};
protoOf(AbstractJsonTreeDecoder).x1i = function (tag, inlineDescriptor) {
  var tmp;
  if (get_isUnsignedNumber(inlineDescriptor)) {
    var tmp_0 = this.d1c();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.getPrimitiveValue' call
    var tmp2 = this.l1i(tag);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = inlineDescriptor.gq();
    if (!(tmp2 instanceof JsonPrimitive)) {
      var tmp_1 = getKClass(JsonPrimitive).ea();
      var tmp_2 = getKClassFromExpression(tmp2).ea();
      var tmp$ret$0 = this.j1i(tag);
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_1 + ', but had ' + tmp_2 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp2));
    }
    var lexer = StringJsonLexer_0(tmp_0, tmp2.h1c());
    tmp = new JsonDecoderForUnsignedTypes(lexer, this.d1c());
  } else {
    tmp = protoOf(NamedValueDecoder).r17.call(this, tag, inlineDescriptor);
  }
  return tmp;
};
protoOf(AbstractJsonTreeDecoder).r17 = function (tag, inlineDescriptor) {
  return this.x1i((!(tag == null) ? typeof tag === 'string' : false) ? tag : THROW_CCE(), inlineDescriptor);
};
protoOf(AbstractJsonTreeDecoder).ps = function (descriptor) {
  return !(this.c17() == null) ? protoOf(NamedValueDecoder).ps.call(this, descriptor) : (new JsonPrimitiveDecoder(this.d1c(), this.w(), this.h1i_1)).ps(descriptor);
};
function setForceNull($this, descriptor, index) {
  $this.h1j_1 = (!$this.d1c().v19_1.n1b_1 && !descriptor.hr(index) && descriptor.gr(index).sq());
  return $this.h1j_1;
}
function JsonTreeDecoder(json, value, polymorphicDiscriminator, polyDescriptor) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  polyDescriptor = polyDescriptor === VOID ? null : polyDescriptor;
  AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
  this.e1j_1 = value;
  this.f1j_1 = polyDescriptor;
  this.g1j_1 = 0;
  this.h1j_1 = false;
}
protoOf(JsonTreeDecoder).w = function () {
  return this.e1j_1;
};
protoOf(JsonTreeDecoder).jt = function (descriptor) {
  $l$loop: while (this.g1j_1 < descriptor.br()) {
    var _unary__edvuaz = this.g1j_1;
    this.g1j_1 = _unary__edvuaz + 1 | 0;
    var name = this.x16(descriptor, _unary__edvuaz);
    var index = this.g1j_1 - 1 | 0;
    this.h1j_1 = false;
    var tmp;
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = this.w();
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).f2(name)) {
      tmp = true;
    } else {
      tmp = setForceNull(this, descriptor, index);
    }
    if (tmp) {
      if (!this.i1i_1.p1b_1)
        return index;
      var tmp0 = this.d1c();
      var tmp$ret$3;
      $l$block_2: {
        // Inline function 'kotlinx.serialization.json.internal.tryCoerceValue' call
        var isOptional = descriptor.hr(index);
        var elementDescriptor = descriptor.gr(index);
        var tmp_0;
        if (isOptional && !elementDescriptor.sq()) {
          var tmp_1 = this.i1j(name);
          tmp_0 = tmp_1 instanceof JsonNull;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$3 = true;
          break $l$block_2;
        }
        if (equals(elementDescriptor.zq(), ENUM_getInstance())) {
          var tmp_2;
          if (elementDescriptor.sq()) {
            var tmp_3 = this.i1j(name);
            tmp_2 = tmp_3 instanceof JsonNull;
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$3 = false;
            break $l$block_2;
          }
          var tmp_4 = this.i1j(name);
          var tmp0_safe_receiver = tmp_4 instanceof JsonPrimitive ? tmp_4 : null;
          var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : get_contentOrNull(tmp0_safe_receiver);
          var tmp_5;
          if (tmp0_elvis_lhs == null) {
            tmp$ret$3 = false;
            break $l$block_2;
          } else {
            tmp_5 = tmp0_elvis_lhs;
          }
          var enumValue = tmp_5;
          var enumIndex = getJsonNameIndex(elementDescriptor, tmp0, enumValue);
          var coerceToNull = !tmp0.v19_1.n1b_1 && elementDescriptor.sq();
          if (enumIndex === -3 && (isOptional || coerceToNull)) {
            if (setForceNull(this, descriptor, index))
              return index;
            tmp$ret$3 = true;
            break $l$block_2;
          }
        }
        tmp$ret$3 = false;
      }
      if (tmp$ret$3)
        continue $l$loop;
      return index;
    }
  }
  return -1;
};
protoOf(JsonTreeDecoder).ds = function () {
  return !this.h1j_1 && protoOf(AbstractJsonTreeDecoder).ds.call(this);
};
protoOf(JsonTreeDecoder).y16 = function (descriptor, index) {
  var strategy = namingStrategy(descriptor, this.d1c());
  var baseName = descriptor.dr(index);
  if (strategy == null) {
    if (!this.i1i_1.t1b_1)
      return baseName;
    if (this.w().d2().q1(baseName))
      return baseName;
  }
  var deserializationNamesMap_0 = deserializationNamesMap(this.d1c(), descriptor);
  // Inline function 'kotlin.collections.find' call
  var tmp0 = this.w().d2();
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.l();
    while (_iterator__ex2g4s.m()) {
      var element = _iterator__ex2g4s.n();
      if (deserializationNamesMap_0.h2(element) === index) {
        tmp$ret$1 = element;
        break $l$block;
      }
    }
    tmp$ret$1 = null;
  }
  var tmp0_safe_receiver = tmp$ret$1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return tmp0_safe_receiver;
  }
  var fallbackName = strategy == null ? null : strategy.y1e(descriptor, index, baseName);
  return fallbackName == null ? baseName : fallbackName;
};
protoOf(JsonTreeDecoder).l1i = function (tag) {
  return getValue(this.w(), tag);
};
protoOf(JsonTreeDecoder).i1j = function (tag) {
  return this.w().g1c(tag);
};
protoOf(JsonTreeDecoder).ss = function (descriptor) {
  if (descriptor === this.f1j_1) {
    var tmp = this.d1c();
    var tmp2 = this.k1i();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonTreeDecoder.cast' call
    // Inline function 'kotlinx.serialization.json.internal.cast' call
    var serialName = this.f1j_1.gq();
    if (!(tmp2 instanceof JsonObject)) {
      var tmp_0 = getKClass(JsonObject).ea();
      var tmp_1 = getKClassFromExpression(tmp2).ea();
      var tmp$ret$0 = this.e17();
      throw JsonDecodingException_0(-1, 'Expected ' + tmp_0 + ', but had ' + tmp_1 + ' as the serialized body of ' + serialName + ' at element: ' + tmp$ret$0, toString(tmp2));
    }
    return new JsonTreeDecoder(tmp, tmp2, this.h1i_1, this.f1j_1);
  }
  return protoOf(AbstractJsonTreeDecoder).ss.call(this, descriptor);
};
protoOf(JsonTreeDecoder).ts = function (descriptor) {
  var tmp;
  if (ignoreUnknownKeys(descriptor, this.d1c())) {
    tmp = true;
  } else {
    var tmp_0 = descriptor.zq();
    tmp = tmp_0 instanceof PolymorphicKind;
  }
  if (tmp)
    return Unit_instance;
  var strategy = namingStrategy(descriptor, this.d1c());
  var tmp_1;
  if (strategy == null && !this.i1i_1.t1b_1) {
    tmp_1 = jsonCachedSerialNames(descriptor);
  } else if (!(strategy == null)) {
    tmp_1 = deserializationNamesMap(this.d1c(), descriptor).d2();
  } else {
    var tmp_2 = jsonCachedSerialNames(descriptor);
    var tmp0_safe_receiver = get_schemaCache(this.d1c()).j1h(descriptor, get_JsonDeserializationNamesKey());
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d2();
    var tmp$ret$0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
    tmp_1 = plus_0(tmp_2, tmp$ret$0);
  }
  var names = tmp_1;
  var _iterator__ex2g4s = this.w().d2().l();
  while (_iterator__ex2g4s.m()) {
    var key = _iterator__ex2g4s.n();
    if (!names.q1(key) && !(key === this.h1i_1)) {
      throw JsonDecodingException_1(-1, "Encountered an unknown key '" + key + "' at element: " + this.e17() + '\n' + "Use 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.w().toString()))));
    }
  }
};
function JsonTreeListDecoder(json, value) {
  AbstractJsonTreeDecoder.call(this, json, value);
  this.p1j_1 = value;
  this.q1j_1 = this.p1j_1.o();
  this.r1j_1 = -1;
}
protoOf(JsonTreeListDecoder).w = function () {
  return this.p1j_1;
};
protoOf(JsonTreeListDecoder).y16 = function (descriptor, index) {
  return index.toString();
};
protoOf(JsonTreeListDecoder).l1i = function (tag) {
  return this.p1j_1.p(toInt(tag));
};
protoOf(JsonTreeListDecoder).jt = function (descriptor) {
  while (this.r1j_1 < (this.q1j_1 - 1 | 0)) {
    this.r1j_1 = this.r1j_1 + 1 | 0;
    return this.r1j_1;
  }
  return -1;
};
function JsonPrimitiveDecoder(json, value, polymorphicDiscriminator) {
  polymorphicDiscriminator = polymorphicDiscriminator === VOID ? null : polymorphicDiscriminator;
  AbstractJsonTreeDecoder.call(this, json, value, polymorphicDiscriminator);
  this.y1j_1 = value;
  this.s17('primitive');
}
protoOf(JsonPrimitiveDecoder).w = function () {
  return this.y1j_1;
};
protoOf(JsonPrimitiveDecoder).jt = function (descriptor) {
  return 0;
};
protoOf(JsonPrimitiveDecoder).l1i = function (tag) {
  // Inline function 'kotlin.require' call
  if (!(tag === 'primitive')) {
    var message = "This input can only handle primitives with 'primitive' tag";
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.y1j_1;
};
function JsonTreeMapDecoder(json, value) {
  JsonTreeDecoder.call(this, json, value);
  this.j1k_1 = value;
  this.k1k_1 = toList(this.j1k_1.d2());
  this.l1k_1 = imul(this.k1k_1.o(), 2);
  this.m1k_1 = -1;
}
protoOf(JsonTreeMapDecoder).w = function () {
  return this.j1k_1;
};
protoOf(JsonTreeMapDecoder).y16 = function (descriptor, index) {
  var i = index / 2 | 0;
  return this.k1k_1.p(i);
};
protoOf(JsonTreeMapDecoder).jt = function (descriptor) {
  while (this.m1k_1 < (this.l1k_1 - 1 | 0)) {
    this.m1k_1 = this.m1k_1 + 1 | 0;
    return this.m1k_1;
  }
  return -1;
};
protoOf(JsonTreeMapDecoder).l1i = function (tag) {
  return (this.m1k_1 % 2 | 0) === 0 ? JsonPrimitive_0(tag) : getValue(this.j1k_1, tag);
};
protoOf(JsonTreeMapDecoder).ts = function (descriptor) {
};
function readPolymorphicJson(_this__u8e3s4, discriminator, element, deserializer) {
  return (new JsonTreeDecoder(_this__u8e3s4, element, discriminator, deserializer.fp())).rs(deserializer);
}
var WriteMode_OBJ_instance;
var WriteMode_LIST_instance;
var WriteMode_MAP_instance;
var WriteMode_POLY_OBJ_instance;
function values() {
  return [WriteMode_OBJ_getInstance(), WriteMode_LIST_getInstance(), WriteMode_MAP_getInstance(), WriteMode_POLY_OBJ_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WriteMode_entriesInitialized;
function WriteMode_initEntries() {
  if (WriteMode_entriesInitialized)
    return Unit_instance;
  WriteMode_entriesInitialized = true;
  WriteMode_OBJ_instance = new WriteMode('OBJ', 0, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_LIST_instance = new WriteMode('LIST', 1, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
  WriteMode_MAP_instance = new WriteMode('MAP', 2, _Char___init__impl__6a9atx(123), _Char___init__impl__6a9atx(125));
  WriteMode_POLY_OBJ_instance = new WriteMode('POLY_OBJ', 3, _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(93));
}
var $ENTRIES;
function WriteMode(name, ordinal, begin, end) {
  Enum.call(this, name, ordinal);
  this.w1h_1 = begin;
  this.x1h_1 = end;
}
function switchMode(_this__u8e3s4, desc) {
  var tmp0_subject = desc.zq();
  var tmp;
  if (tmp0_subject instanceof PolymorphicKind) {
    tmp = WriteMode_POLY_OBJ_getInstance();
  } else {
    if (equals(tmp0_subject, LIST_getInstance())) {
      tmp = WriteMode_LIST_getInstance();
    } else {
      if (equals(tmp0_subject, MAP_getInstance())) {
        // Inline function 'kotlinx.serialization.json.internal.selectMapMode' call
        var keyDescriptor = carrierDescriptor(desc.gr(0), _this__u8e3s4.ht());
        var keyKind = keyDescriptor.zq();
        var tmp_0;
        var tmp_1;
        if (keyKind instanceof PrimitiveKind) {
          tmp_1 = true;
        } else {
          tmp_1 = equals(keyKind, ENUM_getInstance());
        }
        if (tmp_1) {
          tmp_0 = WriteMode_MAP_getInstance();
        } else {
          if (_this__u8e3s4.v19_1.l1b_1) {
            tmp_0 = WriteMode_LIST_getInstance();
          } else {
            throw InvalidKeyKindException(keyDescriptor);
          }
        }
        tmp = tmp_0;
      } else {
        tmp = WriteMode_OBJ_getInstance();
      }
    }
  }
  return tmp;
}
function carrierDescriptor(_this__u8e3s4, module_0) {
  var tmp;
  if (equals(_this__u8e3s4.zq(), CONTEXTUAL_getInstance())) {
    var tmp0_safe_receiver = getContextualDescriptor(module_0, _this__u8e3s4);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : carrierDescriptor(tmp0_safe_receiver, module_0);
    tmp = tmp1_elvis_lhs == null ? _this__u8e3s4 : tmp1_elvis_lhs;
  } else if (_this__u8e3s4.ar()) {
    tmp = carrierDescriptor(_this__u8e3s4.gr(0), module_0);
  } else {
    tmp = _this__u8e3s4;
  }
  return tmp;
}
function WriteMode_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_OBJ_instance;
}
function WriteMode_LIST_getInstance() {
  WriteMode_initEntries();
  return WriteMode_LIST_instance;
}
function WriteMode_MAP_getInstance() {
  WriteMode_initEntries();
  return WriteMode_MAP_instance;
}
function WriteMode_POLY_OBJ_getInstance() {
  WriteMode_initEntries();
  return WriteMode_POLY_OBJ_instance;
}
function appendEscape($this, lastPosition, current) {
  $this.n1k(lastPosition, current);
  return appendEsc($this, current + 1 | 0);
}
function decodedString($this, lastPosition, currentPosition) {
  $this.n1k(lastPosition, currentPosition);
  var result = $this.n1a_1.toString();
  $this.n1a_1.cc(0);
  return result;
}
function takePeeked($this) {
  // Inline function 'kotlin.also' call
  var this_0 = ensureNotNull($this.m1a_1);
  $this.m1a_1 = null;
  return this_0;
}
function wasUnquotedString($this) {
  return !(charSequenceGet($this.o1k(), $this.k1a_1 - 1 | 0) === _Char___init__impl__6a9atx(34));
}
function appendEsc($this, startPosition) {
  var currentPosition = startPosition;
  currentPosition = $this.p1k(currentPosition);
  if (currentPosition === -1) {
    $this.u1e('Expected escape sequence to continue, got EOF');
  }
  var tmp = $this.o1k();
  var _unary__edvuaz = currentPosition;
  currentPosition = _unary__edvuaz + 1 | 0;
  var currentChar = charSequenceGet(tmp, _unary__edvuaz);
  if (currentChar === _Char___init__impl__6a9atx(117)) {
    return appendHex($this, $this.o1k(), currentPosition);
  }
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(currentChar);
  var c = escapeToChar(tmp$ret$0);
  if (c === _Char___init__impl__6a9atx(0)) {
    $this.u1e("Invalid escaped char '" + toString_1(currentChar) + "'");
  }
  $this.n1a_1.l7(c);
  return currentPosition;
}
function appendHex($this, source, startPos) {
  if ((startPos + 4 | 0) >= charSequenceLength(source)) {
    $this.k1a_1 = startPos;
    $this.q1k();
    if (($this.k1a_1 + 4 | 0) >= charSequenceLength(source)) {
      $this.u1e('Unexpected EOF during unicode escape');
    }
    return appendHex($this, source, $this.k1a_1);
  }
  $this.n1a_1.l7(numberToChar((((fromHexChar($this, source, startPos) << 12) + (fromHexChar($this, source, startPos + 1 | 0) << 8) | 0) + (fromHexChar($this, source, startPos + 2 | 0) << 4) | 0) + fromHexChar($this, source, startPos + 3 | 0) | 0));
  return startPos + 4 | 0;
}
function fromHexChar($this, source, currentPosition) {
  var character = charSequenceGet(source, currentPosition);
  var tmp;
  if (_Char___init__impl__6a9atx(48) <= character ? character <= _Char___init__impl__6a9atx(57) : false) {
    // Inline function 'kotlin.code' call
    var tmp_0 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(48);
    tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
  } else if (_Char___init__impl__6a9atx(97) <= character ? character <= _Char___init__impl__6a9atx(102) : false) {
    // Inline function 'kotlin.code' call
    var tmp_1 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(97);
    tmp = (tmp_1 - Char__toInt_impl_vasixd(this_1) | 0) + 10 | 0;
  } else if (_Char___init__impl__6a9atx(65) <= character ? character <= _Char___init__impl__6a9atx(70) : false) {
    // Inline function 'kotlin.code' call
    var tmp_2 = Char__toInt_impl_vasixd(character);
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(65);
    tmp = (tmp_2 - Char__toInt_impl_vasixd(this_2) | 0) + 10 | 0;
  } else {
    $this.u1e("Invalid toHexChar char '" + toString_1(character) + "' in unicode escape");
  }
  return tmp;
}
function consumeBoolean2($this, start) {
  var current = $this.p1k(start);
  if (current >= charSequenceLength($this.o1k()) || current === -1) {
    $this.u1e('EOF');
  }
  var tmp = $this.o1k();
  var _unary__edvuaz = current;
  current = _unary__edvuaz + 1 | 0;
  // Inline function 'kotlin.code' call
  var this_0 = charSequenceGet(tmp, _unary__edvuaz);
  var tmp0_subject = Char__toInt_impl_vasixd(this_0) | 32;
  var tmp_0;
  // Inline function 'kotlin.code' call
  var this_1 = _Char___init__impl__6a9atx(116);
  if (tmp0_subject === Char__toInt_impl_vasixd(this_1)) {
    consumeBooleanLiteral($this, 'rue', current);
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(102);
    if (tmp0_subject === Char__toInt_impl_vasixd(this_2)) {
      consumeBooleanLiteral($this, 'alse', current);
      tmp_0 = false;
    } else {
      $this.u1e("Expected valid boolean literal prefix, but had '" + $this.c1g() + "'");
    }
  }
  return tmp_0;
}
function consumeBooleanLiteral($this, literalSuffix, current) {
  if ((charSequenceLength($this.o1k()) - current | 0) < literalSuffix.length) {
    $this.u1e('Unexpected end of boolean literal');
  }
  var inductionVariable = 0;
  var last = charSequenceLength(literalSuffix) - 1 | 0;
  if (inductionVariable <= last)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var expected = charCodeAt(literalSuffix, i);
      var actual = charSequenceGet($this.o1k(), current + i | 0);
      // Inline function 'kotlin.code' call
      var tmp = Char__toInt_impl_vasixd(expected);
      // Inline function 'kotlin.code' call
      if (!(tmp === (Char__toInt_impl_vasixd(actual) | 32))) {
        $this.u1e("Expected valid boolean literal prefix, but had '" + $this.c1g() + "'");
      }
    }
     while (inductionVariable <= last);
  $this.k1a_1 = current + literalSuffix.length | 0;
}
function consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive) {
  var tmp;
  switch (isExponentPositive) {
    case false:
      // Inline function 'kotlin.math.pow' call

      var x = -toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x);
      break;
    case true:
      // Inline function 'kotlin.math.pow' call

      var x_0 = toNumber(exponentAccumulator);
      tmp = Math.pow(10.0, x_0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function AbstractJsonLexer() {
  this.k1a_1 = 0;
  this.l1a_1 = new JsonPath();
  this.m1a_1 = null;
  this.n1a_1 = StringBuilder_init_$Create$();
}
protoOf(AbstractJsonLexer).q1k = function () {
};
protoOf(AbstractJsonLexer).m1h = function () {
  var current = this.r1k();
  var source = this.o1k();
  if (current >= charSequenceLength(source) || current === -1)
    return false;
  if (charSequenceGet(source, current) === _Char___init__impl__6a9atx(44)) {
    this.k1a_1 = this.k1a_1 + 1 | 0;
    return true;
  }
  return false;
};
protoOf(AbstractJsonLexer).s1k = function (c) {
  return c === _Char___init__impl__6a9atx(125) || c === _Char___init__impl__6a9atx(93) || (c === _Char___init__impl__6a9atx(58) || c === _Char___init__impl__6a9atx(44)) ? false : true;
};
protoOf(AbstractJsonLexer).o1a = function () {
  var nextToken = this.e1g();
  if (!(nextToken === 10)) {
    this.u1e('Expected EOF after parsing, but had ' + toString_1(charSequenceGet(this.o1k(), this.k1a_1 - 1 | 0)) + ' instead');
  }
};
protoOf(AbstractJsonLexer).y1f = function (expected) {
  var token = this.e1g();
  if (!(token === expected)) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expected_0 = tokenDescription(expected);
    var position = true ? this.k1a_1 - 1 | 0 : this.k1a_1;
    var s = this.k1a_1 === charSequenceLength(this.o1k()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.o1k(), position));
    var tmp$ret$0 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
    this.u1e(tmp$ret$0, position);
  }
  return token;
};
protoOf(AbstractJsonLexer).t1k = function (expected) {
  if (this.k1a_1 > 0 && expected === _Char___init__impl__6a9atx(34)) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.withPositionRollback' call
      var snapshot = this.k1a_1;
      try {
        this.k1a_1 = this.k1a_1 - 1 | 0;
        tmp$ret$1 = this.c1g();
        break $l$block;
      }finally {
        this.k1a_1 = snapshot;
      }
    }
    var inputLiteral = tmp$ret$1;
    if (inputLiteral === 'null') {
      this.t1e("Expected string literal but 'null' literal was found", this.k1a_1 - 1 | 0, "Use 'coerceInputValues = true' in 'Json {}' builder to coerce nulls if property has a default value.");
    }
  }
  // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
  var expectedToken = charToTokenClass(expected);
  var expected_0 = tokenDescription(expectedToken);
  var position = true ? this.k1a_1 - 1 | 0 : this.k1a_1;
  var s = this.k1a_1 === charSequenceLength(this.o1k()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.o1k(), position));
  var tmp$ret$2 = 'Expected ' + expected_0 + ", but had '" + s + "' instead";
  this.u1e(tmp$ret$2, position);
};
protoOf(AbstractJsonLexer).z1f = function () {
  var source = this.o1k();
  var cpos = this.k1a_1;
  $l$loop_0: while (true) {
    cpos = this.p1k(cpos);
    if (cpos === -1)
      break $l$loop_0;
    var ch = charSequenceGet(source, cpos);
    if (ch === _Char___init__impl__6a9atx(32) || ch === _Char___init__impl__6a9atx(10) || ch === _Char___init__impl__6a9atx(13) || ch === _Char___init__impl__6a9atx(9)) {
      cpos = cpos + 1 | 0;
      continue $l$loop_0;
    }
    this.k1a_1 = cpos;
    return charToTokenClass(ch);
  }
  this.k1a_1 = cpos;
  return 10;
};
protoOf(AbstractJsonLexer).n1h = function (doConsume) {
  var current = this.r1k();
  current = this.p1k(current);
  var len = charSequenceLength(this.o1k()) - current | 0;
  if (len < 4 || current === -1)
    return false;
  var inductionVariable = 0;
  if (inductionVariable <= 3)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(charCodeAt('null', i) === charSequenceGet(this.o1k(), current + i | 0)))
        return false;
    }
     while (inductionVariable <= 3);
  if (len > 4 && charToTokenClass(charSequenceGet(this.o1k(), current + 4 | 0)) === 0)
    return false;
  if (doConsume) {
    this.k1a_1 = current + 4 | 0;
  }
  return true;
};
protoOf(AbstractJsonLexer).y1h = function (doConsume, $super) {
  doConsume = doConsume === VOID ? true : doConsume;
  return $super === VOID ? this.n1h(doConsume) : $super.n1h.call(this, doConsume);
};
protoOf(AbstractJsonLexer).o1h = function (isLenient) {
  var token = this.z1f();
  var tmp;
  if (isLenient) {
    if (!(token === 1) && !(token === 0))
      return null;
    tmp = this.c1g();
  } else {
    if (!(token === 1))
      return null;
    tmp = this.b1g();
  }
  var string = tmp;
  this.m1a_1 = string;
  return string;
};
protoOf(AbstractJsonLexer).u1k = function () {
  this.m1a_1 = null;
};
protoOf(AbstractJsonLexer).v1k = function (startPos, endPos) {
  // Inline function 'kotlin.text.substring' call
  var this_0 = this.o1k();
  return toString(charSequenceSubSequence(this_0, startPos, endPos));
};
protoOf(AbstractJsonLexer).b1g = function () {
  if (!(this.m1a_1 == null)) {
    return takePeeked(this);
  }
  return this.r1h();
};
protoOf(AbstractJsonLexer).consumeString2 = function (source, startPosition, current) {
  var currentPosition = current;
  var lastPosition = startPosition;
  var char = charSequenceGet(source, currentPosition);
  var usedAppend = false;
  while (!(char === _Char___init__impl__6a9atx(34))) {
    if (char === _Char___init__impl__6a9atx(92)) {
      usedAppend = true;
      currentPosition = this.p1k(appendEscape(this, lastPosition, currentPosition));
      if (currentPosition === -1) {
        this.u1e('Unexpected EOF', currentPosition);
      }
      lastPosition = currentPosition;
    } else {
      currentPosition = currentPosition + 1 | 0;
      if (currentPosition >= charSequenceLength(source)) {
        usedAppend = true;
        this.n1k(lastPosition, currentPosition);
        currentPosition = this.p1k(currentPosition);
        if (currentPosition === -1) {
          this.u1e('Unexpected EOF', currentPosition);
        }
        lastPosition = currentPosition;
      }
    }
    char = charSequenceGet(source, currentPosition);
  }
  var tmp;
  if (!usedAppend) {
    tmp = this.v1k(lastPosition, currentPosition);
  } else {
    tmp = decodedString(this, lastPosition, currentPosition);
  }
  var string = tmp;
  this.k1a_1 = currentPosition + 1 | 0;
  return string;
};
protoOf(AbstractJsonLexer).s1h = function () {
  var result = this.c1g();
  if (result === 'null' && wasUnquotedString(this)) {
    this.u1e("Unexpected 'null' value instead of string literal");
  }
  return result;
};
protoOf(AbstractJsonLexer).c1g = function () {
  if (!(this.m1a_1 == null)) {
    return takePeeked(this);
  }
  var current = this.r1k();
  if (current >= charSequenceLength(this.o1k()) || current === -1) {
    this.u1e('EOF', current);
  }
  var token = charToTokenClass(charSequenceGet(this.o1k(), current));
  if (token === 1) {
    return this.b1g();
  }
  if (!(token === 0)) {
    this.u1e('Expected beginning of the string, but got ' + toString_1(charSequenceGet(this.o1k(), current)));
  }
  var usedAppend = false;
  while (charToTokenClass(charSequenceGet(this.o1k(), current)) === 0) {
    current = current + 1 | 0;
    if (current >= charSequenceLength(this.o1k())) {
      usedAppend = true;
      this.n1k(this.k1a_1, current);
      var eof = this.p1k(current);
      if (eof === -1) {
        this.k1a_1 = current;
        return decodedString(this, 0, 0);
      } else {
        current = eof;
      }
    }
  }
  var tmp;
  if (!usedAppend) {
    tmp = this.v1k(this.k1a_1, current);
  } else {
    tmp = decodedString(this, this.k1a_1, current);
  }
  var result = tmp;
  this.k1a_1 = current;
  return result;
};
protoOf(AbstractJsonLexer).n1k = function (fromIndex, toIndex) {
  this.n1a_1.vb(this.o1k(), fromIndex, toIndex);
};
protoOf(AbstractJsonLexer).q1h = function (allowLenientStrings) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var tokenStack = ArrayList_init_$Create$();
  var lastToken = this.z1f();
  if (!(lastToken === 8) && !(lastToken === 6)) {
    this.c1g();
    return Unit_instance;
  }
  $l$loop: while (true) {
    lastToken = this.z1f();
    if (lastToken === 1) {
      if (allowLenientStrings)
        this.c1g();
      else
        this.r1h();
      continue $l$loop;
    }
    var tmp0_subject = lastToken;
    if (tmp0_subject === 8 || tmp0_subject === 6) {
      tokenStack.j(lastToken);
    } else if (tmp0_subject === 9) {
      if (!(last(tokenStack) === 8))
        throw JsonDecodingException_0(this.k1a_1, 'found ] instead of } at path: ' + this.l1a_1.toString(), this.o1k());
      removeLast(tokenStack);
    } else if (tmp0_subject === 7) {
      if (!(last(tokenStack) === 6))
        throw JsonDecodingException_0(this.k1a_1, 'found } instead of ] at path: ' + this.l1a_1.toString(), this.o1k());
      removeLast(tokenStack);
    } else if (tmp0_subject === 10) {
      this.u1e('Unexpected end of input due to malformed JSON during ignoring unknown keys');
    }
    this.e1g();
    if (tokenStack.o() === 0)
      return Unit_instance;
  }
};
protoOf(AbstractJsonLexer).toString = function () {
  return "JsonReader(source='" + toString(this.o1k()) + "', currentPosition=" + this.k1a_1 + ')';
};
protoOf(AbstractJsonLexer).p1h = function (key) {
  var processed = this.v1k(0, this.k1a_1);
  var lastIndexOf_0 = lastIndexOf(processed, key);
  throw new JsonDecodingException("Encountered an unknown key '" + key + "' at offset " + lastIndexOf_0 + ' at path: ' + this.l1a_1.h1f() + "\nUse 'ignoreUnknownKeys = true' in 'Json {}' builder or '@JsonIgnoreUnknownKeys' annotation to ignore unknown keys.\n" + ('JSON input: ' + toString(minify(this.o1k(), lastIndexOf_0))));
};
protoOf(AbstractJsonLexer).t1e = function (message, position, hint) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(hint) === 0) {
    tmp = '';
  } else {
    tmp = '\n' + hint;
  }
  var hintMessage = tmp;
  throw JsonDecodingException_0(position, message + ' at path: ' + this.l1a_1.h1f() + hintMessage, this.o1k());
};
protoOf(AbstractJsonLexer).u1e = function (message, position, hint, $super) {
  position = position === VOID ? this.k1a_1 : position;
  hint = hint === VOID ? '' : hint;
  return $super === VOID ? this.t1e(message, position, hint) : $super.t1e.call(this, message, position, hint);
};
protoOf(AbstractJsonLexer).a1i = function () {
  var current = this.r1k();
  current = this.p1k(current);
  if (current >= charSequenceLength(this.o1k()) || current === -1) {
    this.u1e('EOF');
  }
  var tmp;
  if (charSequenceGet(this.o1k(), current) === _Char___init__impl__6a9atx(34)) {
    current = current + 1 | 0;
    if (current === charSequenceLength(this.o1k())) {
      this.u1e('EOF');
    }
    tmp = true;
  } else {
    tmp = false;
  }
  var hasQuotation = tmp;
  var accumulator = 0n;
  var exponentAccumulator = 0n;
  var isNegative = false;
  var isExponentPositive = false;
  var hasExponent = false;
  var start = current;
  $l$loop_4: while (!(current === charSequenceLength(this.o1k()))) {
    var ch = charSequenceGet(this.o1k(), current);
    if ((ch === _Char___init__impl__6a9atx(101) || ch === _Char___init__impl__6a9atx(69)) && !hasExponent) {
      if (current === start) {
        this.u1e('Unexpected symbol ' + toString_1(ch) + ' in numeric literal');
      }
      isExponentPositive = true;
      hasExponent = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(45) && hasExponent) {
      if (current === start) {
        this.u1e("Unexpected symbol '-' in numeric literal");
      }
      isExponentPositive = false;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(43) && hasExponent) {
      if (current === start) {
        this.u1e("Unexpected symbol '+' in numeric literal");
      }
      isExponentPositive = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    if (ch === _Char___init__impl__6a9atx(45)) {
      if (!(current === start)) {
        this.u1e("Unexpected symbol '-' in numeric literal");
      }
      isNegative = true;
      current = current + 1 | 0;
      continue $l$loop_4;
    }
    var token = charToTokenClass(ch);
    if (!(token === 0))
      break $l$loop_4;
    current = current + 1 | 0;
    var digit = Char__minus_impl_a2frrh(ch, _Char___init__impl__6a9atx(48));
    if (!(0 <= digit ? digit <= 9 : false)) {
      this.u1e("Unexpected symbol '" + toString_1(ch) + "' in numeric literal");
    }
    if (hasExponent) {
      // Inline function 'kotlin.Long.times' call
      var this_0 = exponentAccumulator;
      // Inline function 'kotlin.Long.plus' call
      var this_1 = multiply(this_0, fromInt(10));
      exponentAccumulator = add(this_1, fromInt(digit));
      continue $l$loop_4;
    }
    // Inline function 'kotlin.Long.times' call
    var this_2 = accumulator;
    // Inline function 'kotlin.Long.minus' call
    var this_3 = multiply(this_2, fromInt(10));
    accumulator = subtract(this_3, fromInt(digit));
    if (accumulator > 0n) {
      this.u1e('Numeric value overflow');
    }
  }
  var hasChars = !(current === start);
  if (start === current || (isNegative && start === (current - 1 | 0))) {
    this.u1e('Expected numeric literal');
  }
  if (hasQuotation) {
    if (!hasChars) {
      this.u1e('EOF');
    }
    if (!(charSequenceGet(this.o1k(), current) === _Char___init__impl__6a9atx(34))) {
      this.u1e('Expected closing quotation mark');
    }
    current = current + 1 | 0;
  }
  this.k1a_1 = current;
  if (hasExponent) {
    var doubleAccumulator = toNumber(accumulator) * consumeNumericLiteral$calculateExponent(exponentAccumulator, isExponentPositive);
    if (doubleAccumulator > toNumber(9223372036854775807n) || doubleAccumulator < toNumber(-9223372036854775808n)) {
      this.u1e('Numeric value overflow');
    }
    // Inline function 'kotlin.math.floor' call
    if (!(Math.floor(doubleAccumulator) === doubleAccumulator)) {
      this.u1e("Can't convert " + doubleAccumulator + ' to Long');
    }
    accumulator = numberToLong(doubleAccumulator);
  }
  var tmp_0;
  if (isNegative) {
    tmp_0 = accumulator;
  } else if (!(accumulator === -9223372036854775808n)) {
    tmp_0 = negate(accumulator);
  } else {
    this.u1e('Numeric value overflow');
  }
  return tmp_0;
};
protoOf(AbstractJsonLexer).s1c = function () {
  var result = this.a1i();
  var next = this.e1g();
  if (!(next === 10)) {
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expected = tokenDescription(10);
    var position = true ? this.k1a_1 - 1 | 0 : this.k1a_1;
    var s = this.k1a_1 === charSequenceLength(this.o1k()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.o1k(), position));
    var tmp$ret$0 = "Expected input to contain a single valid number, but got '" + s + "' after it";
    this.u1e(tmp$ret$0, position);
  }
  return result;
};
protoOf(AbstractJsonLexer).z1h = function () {
  var current = this.r1k();
  if (current === charSequenceLength(this.o1k())) {
    this.u1e('EOF');
  }
  var tmp;
  if (charSequenceGet(this.o1k(), current) === _Char___init__impl__6a9atx(34)) {
    current = current + 1 | 0;
    tmp = true;
  } else {
    tmp = false;
  }
  var hasQuotation = tmp;
  var result = consumeBoolean2(this, current);
  if (hasQuotation) {
    if (this.k1a_1 === charSequenceLength(this.o1k())) {
      this.u1e('EOF');
    }
    if (!(charSequenceGet(this.o1k(), this.k1a_1) === _Char___init__impl__6a9atx(34))) {
      this.u1e('Expected closing quotation mark');
    }
    this.k1a_1 = this.k1a_1 + 1 | 0;
  }
  return result;
};
function charToTokenClass(c) {
  var tmp;
  // Inline function 'kotlin.code' call
  if (Char__toInt_impl_vasixd(c) < 126) {
    var tmp_0 = CharMappings_getInstance().x1k_1;
    // Inline function 'kotlin.code' call
    tmp = tmp_0[Char__toInt_impl_vasixd(c)];
  } else {
    tmp = 0;
  }
  return tmp;
}
function tokenDescription(token) {
  return token === 1 ? "quotation mark '\"'" : token === 2 ? "string escape sequence '\\'" : token === 4 ? "comma ','" : token === 5 ? "colon ':'" : token === 6 ? "start of the object '{'" : token === 7 ? "end of the object '}'" : token === 8 ? "start of the array '['" : token === 9 ? "end of the array ']'" : token === 10 ? 'end of the input' : token === 127 ? 'invalid token' : 'valid token';
}
function escapeToChar(c) {
  return c < 117 ? CharMappings_getInstance().w1k_1[c] : _Char___init__impl__6a9atx(0);
}
function initEscape($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 31)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2ESC($this, i, _Char___init__impl__6a9atx(117));
    }
     while (inductionVariable <= 31);
  initC2ESC($this, 8, _Char___init__impl__6a9atx(98));
  initC2ESC($this, 9, _Char___init__impl__6a9atx(116));
  initC2ESC($this, 10, _Char___init__impl__6a9atx(110));
  initC2ESC($this, 12, _Char___init__impl__6a9atx(102));
  initC2ESC($this, 13, _Char___init__impl__6a9atx(114));
  initC2ESC_0($this, _Char___init__impl__6a9atx(47), _Char___init__impl__6a9atx(47));
  initC2ESC_0($this, _Char___init__impl__6a9atx(34), _Char___init__impl__6a9atx(34));
  initC2ESC_0($this, _Char___init__impl__6a9atx(92), _Char___init__impl__6a9atx(92));
}
function initCharToToken($this) {
  var inductionVariable = 0;
  if (inductionVariable <= 32)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      initC2TC($this, i, 127);
    }
     while (inductionVariable <= 32);
  initC2TC($this, 9, 3);
  initC2TC($this, 10, 3);
  initC2TC($this, 13, 3);
  initC2TC($this, 32, 3);
  initC2TC_0($this, _Char___init__impl__6a9atx(44), 4);
  initC2TC_0($this, _Char___init__impl__6a9atx(58), 5);
  initC2TC_0($this, _Char___init__impl__6a9atx(123), 6);
  initC2TC_0($this, _Char___init__impl__6a9atx(125), 7);
  initC2TC_0($this, _Char___init__impl__6a9atx(91), 8);
  initC2TC_0($this, _Char___init__impl__6a9atx(93), 9);
  initC2TC_0($this, _Char___init__impl__6a9atx(34), 1);
  initC2TC_0($this, _Char___init__impl__6a9atx(92), 2);
}
function initC2ESC($this, c, esc) {
  if (!(esc === _Char___init__impl__6a9atx(117))) {
    // Inline function 'kotlin.code' call
    var tmp$ret$0 = Char__toInt_impl_vasixd(esc);
    $this.w1k_1[tmp$ret$0] = numberToChar(c);
  }
}
function initC2ESC_0($this, c, esc) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2ESC($this, tmp$ret$0, esc);
}
function initC2TC($this, c, cl) {
  $this.x1k_1[c] = cl;
}
function initC2TC_0($this, c, cl) {
  // Inline function 'kotlin.code' call
  var tmp$ret$0 = Char__toInt_impl_vasixd(c);
  return initC2TC($this, tmp$ret$0, cl);
}
function CharMappings() {
  CharMappings_instance = this;
  this.w1k_1 = charArray(117);
  this.x1k_1 = new Int8Array(126);
  initEscape(this);
  initCharToToken(this);
}
var CharMappings_instance;
function CharMappings_getInstance() {
  if (CharMappings_instance == null)
    new CharMappings();
  return CharMappings_instance;
}
function StringJsonLexerWithComments(source) {
  StringJsonLexer.call(this, source);
}
protoOf(StringJsonLexerWithComments).e1g = function () {
  var source = this.o1k();
  var cpos = this.r1k();
  if (cpos >= source.length || cpos === -1)
    return 10;
  this.k1a_1 = cpos + 1 | 0;
  return charToTokenClass(charCodeAt(source, cpos));
};
protoOf(StringJsonLexerWithComments).a1g = function () {
  var current = this.r1k();
  if (current >= this.o1k().length || current === -1)
    return false;
  return this.s1k(charCodeAt(this.o1k(), current));
};
protoOf(StringJsonLexerWithComments).l1h = function (expected) {
  var source = this.o1k();
  var current = this.r1k();
  if (current >= source.length || current === -1) {
    this.k1a_1 = -1;
    this.t1k(expected);
  }
  var c = charCodeAt(source, current);
  this.k1a_1 = current + 1 | 0;
  if (c === expected)
    return Unit_instance;
  else {
    this.t1k(expected);
  }
};
protoOf(StringJsonLexerWithComments).z1f = function () {
  var source = this.o1k();
  var cpos = this.r1k();
  if (cpos >= source.length || cpos === -1)
    return 10;
  this.k1a_1 = cpos;
  return charToTokenClass(charCodeAt(source, cpos));
};
protoOf(StringJsonLexerWithComments).r1k = function () {
  var current = this.k1a_1;
  if (current === -1)
    return current;
  var source = this.o1k();
  $l$loop_1: while (current < source.length) {
    var c = charCodeAt(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
      continue $l$loop_1;
    }
    if (c === _Char___init__impl__6a9atx(47) && (current + 1 | 0) < source.length) {
      var tmp0_subject = charCodeAt(source, current + 1 | 0);
      if (tmp0_subject === _Char___init__impl__6a9atx(47)) {
        current = indexOf_0(source, _Char___init__impl__6a9atx(10), current + 2 | 0);
        if (current === -1) {
          current = source.length;
        } else {
          current = current + 1 | 0;
        }
        continue $l$loop_1;
      } else if (tmp0_subject === _Char___init__impl__6a9atx(42)) {
        current = indexOf(source, '*/', current + 2 | 0);
        if (current === -1) {
          this.k1a_1 = source.length;
          this.u1e('Expected end of the block comment: "*/", but had EOF instead');
        } else {
          current = current + 2 | 0;
        }
        continue $l$loop_1;
      }
    }
    break $l$loop_1;
  }
  this.k1a_1 = current;
  return current;
};
function StringJsonLexer(source) {
  AbstractJsonLexer.call(this);
  this.h1l_1 = source;
}
protoOf(StringJsonLexer).o1k = function () {
  return this.h1l_1;
};
protoOf(StringJsonLexer).p1k = function (position) {
  return position < this.o1k().length ? position : -1;
};
protoOf(StringJsonLexer).e1g = function () {
  var source = this.o1k();
  var cpos = this.k1a_1;
  $l$loop: while (!(cpos === -1) && cpos < source.length) {
    var _unary__edvuaz = cpos;
    cpos = _unary__edvuaz + 1 | 0;
    var c = charCodeAt(source, _unary__edvuaz);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
      continue $l$loop;
    this.k1a_1 = cpos;
    return charToTokenClass(c);
  }
  this.k1a_1 = source.length;
  return 10;
};
protoOf(StringJsonLexer).a1g = function () {
  var current = this.k1a_1;
  if (current === -1)
    return false;
  var source = this.o1k();
  $l$loop: while (current < source.length) {
    var c = charCodeAt(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
      continue $l$loop;
    }
    this.k1a_1 = current;
    return this.s1k(c);
  }
  this.k1a_1 = current;
  return false;
};
protoOf(StringJsonLexer).r1k = function () {
  var current = this.k1a_1;
  if (current === -1)
    return current;
  var source = this.o1k();
  $l$loop: while (current < source.length) {
    var c = charCodeAt(source, current);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9)) {
      current = current + 1 | 0;
    } else {
      break $l$loop;
    }
  }
  this.k1a_1 = current;
  return current;
};
protoOf(StringJsonLexer).l1h = function (expected) {
  if (this.k1a_1 === -1) {
    this.t1k(expected);
  }
  var source = this.o1k();
  var cpos = this.k1a_1;
  $l$loop: while (cpos < source.length) {
    var _unary__edvuaz = cpos;
    cpos = _unary__edvuaz + 1 | 0;
    var c = charCodeAt(source, _unary__edvuaz);
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.isWs' call
    if (c === _Char___init__impl__6a9atx(32) || c === _Char___init__impl__6a9atx(10) || c === _Char___init__impl__6a9atx(13) || c === _Char___init__impl__6a9atx(9))
      continue $l$loop;
    this.k1a_1 = cpos;
    if (c === expected)
      return Unit_instance;
    this.t1k(expected);
  }
  this.k1a_1 = -1;
  this.t1k(expected);
};
protoOf(StringJsonLexer).r1h = function () {
  this.l1h(_Char___init__impl__6a9atx(34));
  var current = this.k1a_1;
  var closingQuote = indexOf_0(this.o1k(), _Char___init__impl__6a9atx(34), current);
  if (closingQuote === -1) {
    this.c1g();
    // Inline function 'kotlinx.serialization.json.internal.AbstractJsonLexer.fail' call
    var expected = tokenDescription(1);
    var position = false ? this.k1a_1 - 1 | 0 : this.k1a_1;
    var s = this.k1a_1 === charSequenceLength(this.o1k()) || position < 0 ? 'EOF' : toString_1(charSequenceGet(this.o1k(), position));
    var tmp$ret$0 = 'Expected ' + expected + ", but had '" + s + "' instead";
    this.u1e(tmp$ret$0, position);
  }
  var inductionVariable = current;
  if (inductionVariable < closingQuote)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (charCodeAt(this.o1k(), i) === _Char___init__impl__6a9atx(92)) {
        return this.consumeString2(this.o1k(), this.k1a_1, i);
      }
    }
     while (inductionVariable < closingQuote);
  this.k1a_1 = closingQuote + 1 | 0;
  return substring(this.o1k(), current, closingQuote);
};
protoOf(StringJsonLexer).t1h = function (keyToMatch, isLenient) {
  var positionSnapshot = this.k1a_1;
  try {
    if (!(this.e1g() === 6))
      return null;
    var firstKey = this.o1h(isLenient);
    if (!(firstKey === keyToMatch))
      return null;
    this.u1k();
    if (!(this.e1g() === 5))
      return null;
    return this.o1h(isLenient);
  }finally {
    this.k1a_1 = positionSnapshot;
    this.u1k();
  }
};
function StringJsonLexer_0(json, source) {
  return !json.v19_1.x1b_1 ? new StringJsonLexer(source) : new StringJsonLexerWithComments(source);
}
function get_schemaCache(_this__u8e3s4) {
  return _this__u8e3s4.x19_1;
}
function JsonToStringWriter() {
  this.a1a_1 = StringBuilder_init_$Create$_0(128);
}
protoOf(JsonToStringWriter).y1d = function (value) {
  this.a1a_1.zb(value);
};
protoOf(JsonToStringWriter).s1d = function (char) {
  this.a1a_1.l7(char);
};
protoOf(JsonToStringWriter).u1d = function (text) {
  this.a1a_1.k7(text);
};
protoOf(JsonToStringWriter).e1e = function (text) {
  printQuoted(this.a1a_1, text);
};
protoOf(JsonToStringWriter).b1a = function () {
  this.a1a_1.dc();
};
protoOf(JsonToStringWriter).toString = function () {
  return this.a1a_1.toString();
};
function createMapForCache(initialCapacity) {
  return HashMap_init_$Create$(initialCapacity);
}
//region block: post-declaration
protoOf(defer$1).sq = get_isNullable;
protoOf(defer$1).ar = get_isInline;
protoOf(defer$1).cr = get_annotations;
protoOf(JsonSerializersModuleValidator).o19 = contextual;
//endregion
//region block: init
Companion_instance = new Companion();
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
Companion_instance_2 = new Companion_2();
Tombstone_instance = new Tombstone();
//endregion
//region block: exports
export {
  Default_getInstance as Default_getInstance363hicrc7jsft,
  JsonContentPolymorphicSerializer as JsonContentPolymorphicSerializer1zt3sp8asmujz,
  Json_0 as Jsonsmkyu9xjl7fv,
  get_intOrNull as get_intOrNulld29i64b3udf,
  get_jsonArray as get_jsonArray18sglwhl4pclz,
  get_jsonObject as get_jsonObject2u4z2ch1uuca9,
  get_jsonPrimitive as get_jsonPrimitivez17tyd5rw1ql,
  get_longOrNull as get_longOrNull1kg1ha9scz5pa,
};
//endregion

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-json.mjs.map
